import React, { useEffect, useRef, useState ,useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadIcon from '@mui/icons-material/Download';
import Modal from "@mui/material/Modal";
import PersonIcon from "@mui/icons-material/Person";
import Box from "@mui/material/Box";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import checkImage from "../../assests/images/check-circle.png";
import { rfqServices } from "../../services/rfqServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { getSecPermission, isEmptyDash, strToDate, strToDateYYMMDD, totalInr, trimString, urlConstants } from "../../constant";
import _, { indexOf } from "lodash";
import { onboardingServices } from "../../services/onboardingServices";
import PackageDocuments from "../projectManagerScreens/packageDocuments";
import CreateNewVendorModal from "../common/createNewVendorModal";
import { vendorServices } from "../../services/vendorServices";
import { validationServices } from "../../services/validationServices";
import DayCountdown from "../common/dayCountDown";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import ExitingVendor from "../common/rfqExitingVendorModal";
import { UserObj } from "../../services/localStarage";
import SupportChat from "../support/chat";
import BoqDescriptionModal from "../common/boqDescriptionModal";
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from "@mui/icons-material/Delete";
import { packageServices } from "../../services/packageServices";
import BulkUploadModal from "../common/bulkUpload";
import * as XLSX from "xlsx";
import sampleRFQFile from "../../assests/document/bulk_rfq_boq.xlsx"; 
import msgIco from "../../assests/images/msg-ico.png";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}));

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const createTableArr1 = [
  { label: "Description", name: "description", value: "Description", options: [], errMsg: "" },
  { label: "HSN/SAC Code", name: "hsnSacCode", value: "HSN/SAC Code", options: [], errMsg: "" },
  { label: "UOM", name: "uom", value: "UOM", options: [], errMsg: "" },
  { label: "Quantity", name: "quantity", value: "Quantity", options: [], errMsg: "" },
];
const packageDocsArr = ["bom", "tendorDrawing", "technicalSpecification", "makeListUpload", "additionalDocuments"];
const rfqDocsArr = ["termSheet", "listOfConstructionMaterials", "vendorInformation", "generalConditions", "abacPolicy", "qualityRequirement", "approvedMakeList", "resourceMobilisationSchedule"];
const statusArr = ["Initiated", "Drafted", "Created", "Approved", "Rejected", "Hold", "Published", "Technical_Evaluation_In_Progress", "Technical_Evaluation_Done", "Commercial_Evaluation_In_Progress", "Round_1_Completed", "Round_2_Initiated", "Round_2_Published", "Round_2_Completed"];

let inviteQuesArr1 = [
  {
    title: "Contact Name",
    name: "contactName",
    type: "text",
    placeholder: "Contact Name",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter the valid contact name.",
    value: "",
    validationType: "text",
  },
  {
    title: "Contact Number",
    name: "contactNumber",
    type: "text",
    placeholder: "Contact Number",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter a valid 10-digit mobile number.",
    value: "",
    validationType: "number",
  },

  {
    title: "Vendor Name",
    name: "vendorName",
    type: "text",
    placeholder: "Vendor Name",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter the valid vendor name.",
    value: "",
    validationType: "text",
  },
  {
    title: "Vendor Email",
    name: "vendorEmail",
    type: "text",
    placeholder: "Vendor Email",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please enter the vendor email.",
    value: "",
    validationType: "email",
  },
  {
    title: "Onboarding Type",
    name: "onboardingType",
    type: "select",
    placeholder: "Onboarding Type",
    isRequired: true,
    showAlert: false,
    disabled: false,
    alertMsg: "Please select onboarding type.",
    value: "REGULAR_ONBOARDING",
    validationType: "",
    options: [
      { label: "Regular Onboarding", value: "REGULAR_ONBOARDING" },
      { label: "Direct Onboarding", value: "DIRECT_ONBOARDING" },
      {
        label: "Onboarding without Document",
        value: "ONBOARDING_WITHOUT_DOCUMENTS",
      },
    ],
  },
];

const userRole = UserObj?.role?.name;
const userId = UserObj?._id; 
const permissionInit = {
  "create": false,
  "read": false,
  "update": false,
  "delete": false
};

function RfqCreactionForm() {
  const { id } = useParams();
  let navigate = useNavigate();
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);

  const [openexistingvendorrfq, setOpenExistingVendorRfq] = useState(false);
  const [inviteQuesArr, setInviteQuesArr] = useState(inviteQuesArr1);
  const [createVendorOpen, setCreateVendorOpen] = useState(false);
  const [sucessMoaldOpen, setSuccessModalOpen] = useState(false);
  const [isCountDownStart, setIsCountDownStart] = useState(false);
  const [isAgainstPkg, setIsAgainstPkg] = useState(false);
  const [opencreationupdateboqmodal, setOpenCreationUpdateBoqModal] =
    useState(false);
  const [
    openrfqcreationnotificationmodifiedmodal,
    setOpenRfqCreationNotificationModifiedModal,
  ] = useState(false);
  const [deleteRFQModal, setDeleteRFQModal] = useState(false);
  const [openinvitednewvendormodal, setOpenInvitedNewVendorModal] =
    useState(false);
  const [
    openselectroundtworfqdetailmodal,
    setOpenSelectRoundTwoRfqDetailModal,
  ] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [isRejectListModalOpen, setIsRejectListModalOpen] = useState(false);
  const [isEditRFQ, setIsEditRFQ] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});
  const [vendorDetails, setVendorDetails] = useState({});
  const [vendorTableDataArr, setVendorTableDataArr] = useState([]);
  const [rejectedVendorArr, setRejectedVendor] = useState([]);
  const [createdNewRFQNo, setCreatedNewRFQNo] = useState("");

  const [initiateObjR2, setInitiateObjR2] = React.useState({
    "Approved": [],
    "Rejected": [],
  });
  const [openboqupdatesuccessfully, setOpenBoqUpdateSuccessfully] =
    useState(false);
  const [existingVendor, setexistingVendor] = useState("");
  const [existingVendorDataList, setexistingVendorDataList] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [editSubmitStatus, setEditSubmitStatus] = useState(null);
  const [initialBoqs, setInitialBoqs] = useState([]);
  const [rfqDetails, setRfqDetails] = React.useState({
    boqs: [],
    documents: [],
    rounds: [],
    rfqVendors: [],
    rfqValidity: { "from": null, "to": null },
  });
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const [secRFQPermission, setSecRFQPermission] = useState({
    "EXTEND_VENDOR": permissionInit,
    "EDIT_QUANTITY_RFQ": permissionInit,
    "EDIT_UOM_RFQ": permissionInit,
    "EDIT_DESCRIPTION_RFQ": permissionInit,
    "EDIT_PURCHASE_TYPE_RFQ": permissionInit,

    "RFQ_WITHOUT_PACKAGE": permissionInit,
    "BOQ_DELETE_ROW": permissionInit,
    "BOQ_EDIT_RATE": permissionInit,
    "BOQ_EDIT_HSN/SAC_CODE": permissionInit,
    "EDIT_RFQ": permissionInit,

    "RFQ_WITH_PACKAGE": permissionInit,
    "FILE_RESOURCE_MOBILISATION_SCHEDULE": permissionInit,
    "FILE_AVAADA_QUALITY_REQUIREMENT_": permissionInit,
    "FILE_ABAC_POLICY": permissionInit,
    "FILE_GENERAL_CONDITIONS_OF_CONTRACT_(SERVICE)": permissionInit,

    "FILE_VENDOR_INFORMATION": permissionInit,
    "FILE_LIST_OF_CONSTRUCTION_MATERIALS": permissionInit,
    "FILE_TERM_SHEET": permissionInit,

    "FILE_APPROVED_MAKE_LIST_RFQ": permissionInit,
    "FILE_MAKE_LIST_RFQ": permissionInit,
    "FILE_TECHNICAL_SPECIFICATION_RFQ": permissionInit,
    "FILE_TENDOR_DRAWING_RFQ": permissionInit,
    "FILE_BOM_RFQ": permissionInit,

    "TECHNICAL_EVALUATION": permissionInit,
    "COMMERCIAL_EVALUATION": permissionInit,
    "DELETE_RFQ": permissionInit,
  });

  const [rfqDetailsClone, setRfqDetailsClone] = React.useState({
    boqs: [],
    documents: [],
    rounds: [],
    rfqVendors: [],
    rfqValidity: { "from": null, "to": null },
  });

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const fileInputRef = useRef([]); 
  const filePackageInputRef = useRef([]);
  const fileRFQInputRef = useRef([]);

  const [isEdited, setIsEdited] = useState(false);
   
  useEffect(() => {
    getRFQDetails(id);
    let secRFQPermissionInit = _.cloneDeep(secRFQPermission);
    let obj = {};
    for (let key in secRFQPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecRFQPermission(obj);

    if (UserObj?.role.name == "VENDOR") {
      getVendorDetails();
    }
    // let permissionObj = getSecPermission("PACKAGE_LISTING");
    // setSecPackagePermission(permissionObj);
  }, []);

  useEffect(() => {
    setVendorTableDataArr(rfqDetails?.rfqVendors);
    setInitialBoqs(rfqDetails?.boqs);
  }, [rfqDetails?.rfqVendors]);

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };

  const editRFQ = () => {
    setIsEditRFQ(true);
    setOpenRfqCreationNotificationModifiedModal(false);
  };
  const [todayDate, setTodayDate] = useState('');
  useEffect(() => {
    // Set today's date on component mount
    const today = new Date().toISOString().split('T')[0];
    setTodayDate(today);
  }, []);
  const getRFQDocPermission = (data) => {
    switch (data?.uniqueName) {
      case "tendorDrawing":
        return secRFQPermission?.FILE_TENDOR_DRAWING_RFQ;
        break;
      case "technicalSpecification":
        return secRFQPermission?.FILE_TECHNICAL_SPECIFICATION_RFQ;

        break;
      case "bom":
        return secRFQPermission?.FILE_BOM_RFQ;

        break;
      case "makeListUpload":
        return secRFQPermission?.FILE_MAKE_LIST_RFQ;

        break;
      case "approvedMakeList":
        return secRFQPermission?.FILE_APPROVED_MAKE_LIST_RFQ;

        break;
      case "termSheet":
        return secRFQPermission?.FILE_TERM_SHEET;

        break;
      case "listOfConstructionMaterials":
        return secRFQPermission?.FILE_LIST_OF_CONSTRUCTION_MATERIALS;

        break;
      case "vendorInformation":
        return secRFQPermission?.FILE_VENDOR_INFORMATION;

        break;
      case "generalConditions":
        return secRFQPermission["FILE_GENERAL_CONDITIONS_OF_CONTRACT_(SERVICE)"];

        break;
      case "abacPolicy":
        return secRFQPermission?.FILE_ABAC_POLICY;

        break;
      case "qualityRequirement":
        return secRFQPermission?.FILE_AVAADA_QUALITY_REQUIREMENT_;

        break;
      case "resourceMobilisationSchedule":
        return secRFQPermission?.FILE_RESOURCE_MOBILISATION_SCHEDULE;

        break;

      default:
        return { ...permissionInit }
        break;
    }
  };


  const getVendorDetails = (url) => {
    setIsLoading(true);
    vendorServices
      .getVendorDetails()
      .then(function (response) {
        if (response?.data?.success == true) {
          setVendorDetails(response?.data?.data);
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onUploadMedia = (resData, uploadObj, files, data2) => {  
    let obj = {
      key: encodeKey(resData?.data?.Key),
      fileName: files?.name,
    };
    if (data2?.vendorResponse == true) {
      uploadObj.response[data2?.index].vendorResponse = obj;
      uploadObj.response[data2?.index].acknowledged = data2?.isAccept;
    } else {
    
      // uploadObj.response.push(obj);
      uploadObj.response.push(obj);
      // if(!isEmptyDash(uploadObj.response)){
      //   uploadObj.response.push(obj);
      // }else{
      //   uploadObj.value.response.push(obj);
      // } 
    } 
    setUploadFilesObj(uploadObj);
  };

  const acceptAcknowledge = (uploadObj, data2) => {
    uploadObj.response[data2?.index].acknowledged = data2?.isAccept;
    delete uploadObj.response[data2?.index].vendorResponse;
    setUploadFilesObj(uploadObj); 
    
  };

  const onMediaActionChange = (param) => {
    console.log(param);
  };
 
  const inviteModalClose = () => {
    let inviteQuesArrClone = [...inviteQuesArr];
    for (let i = 0; i < inviteQuesArrClone.length; i++) {
      if (inviteQuesArrClone[i].type == "text") {
        inviteQuesArrClone[i].value = "";
      }
    }

    setInviteQuesArr(inviteQuesArrClone);
    setCreateVendorOpen(false);
  };

  const validateForm = () => {
    let inviteQuesArrClone = [...inviteQuesArr];
    let isValidate = true;
    let bodyData = {};
    bodyData['isAllowedToBid'] = true;


    for (let i = 0; i < inviteQuesArrClone.length; i++) {
      inviteQuesArrClone[i].showAlert = false;
      bodyData[inviteQuesArrClone[i].name] = inviteQuesArrClone[i].value;


      if (isEmptyDash(inviteQuesArrClone[i].value)) {
        isValidate = false;
        inviteQuesArrClone[i].showAlert = true;
      }

      // Che 
      if (inviteQuesArrClone[i].validationType === "number") {
        let validationRes = validationServices.validatePhoneNumber(inviteQuesArrClone[i].value);
        if (!validationRes) {
          isValidate = false;
          inviteQuesArrClone[i].showAlert = true;
        }
      }

      if (inviteQuesArrClone[i].validationType === "text") {
        let validationRes = validationServices.validateText(inviteQuesArrClone[i].value);
        if (!validationRes) {
          isValidate = false;
          inviteQuesArrClone[i].showAlert = true;
        }
      }
    }


    setInviteQuesArr(inviteQuesArrClone);

    if (isValidate) {
      setIsLoading(true);
      vendorServices
        .createVendorInvite(bodyData)
        .then((res) => {
          // setVendorTableDataArr((prevState) => ([res.data?.data?.vendor, ...prevState ]));
          extendVendor(false, [res.data?.data?.vendor?._id]);
          setCreateVendorOpen(false);
          setInviteQuesArr(inviteQuesArr1);
        })
        .catch(function (error) {
          setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }
  };
  const [VendorParticipationStatus, setVendorParticipationStatusNotPending] = useState(false);
  const [VendorSubmitedStatus, setVendorSubmitedStatus] = useState('');
  
  const getRFQDetails = (param) => {
    setIsLoading(true);
    let data = `/${param}`;

    let promise = "";
    if (userRole == "VENDOR") {
      promise = rfqServices.getVendorRfqListing(data);
    } else {
      promise = rfqServices.getRfqListing(data);
    }

    // rfqServices.getRfqListing(data)
    promise.then((res) => {
      if (res.data.success === true) {
        // for (let i = 0; i < res.data?.data?.boqs.length; i++) {              
        //   if (secRFQPermission["BOQ_EDIT_HSN/SAC_CODE"]?.read == true) {
        //     res.data?.data?.boqs[i]["BOQ_EDIT_HSN/SAC_CODE"] = true
        //   } 
        // } 
        const isVendorParticipationStatusNotPending = res.data?.data?.rfqVendors?.some(
          (vendor) => vendor.participationStatus !== "Pending To Participate"
        );
        setVendorParticipationStatusNotPending(isVendorParticipationStatusNotPending);

        const isVendorParticipationStatusSubmited = res.data?.data?.rfqVendors?.some(
          (vendor) => vendor.participationStatus === "Submitted"
        );
        setVendorSubmitedStatus(isVendorParticipationStatusSubmited);
        if (isEmptyDash(res.data?.data?.packageCode) && res.data?.data?.status == "Initiated") {

          if (!res.data.data.boqs || res.data.data.boqs.length === 0) {
            res.data.data.boqs = [
              {
                description: "",
                hsnSacCode: "",
                uom: "",
                quantity: null,
              },
            ];
          }
        }

        if (res.data?.data?.status == "Drafted" || res.data?.data?.status == "Initiated") {
          setIsEditRFQ(true);
        }
        if (!isEmptyDash(res.data?.data?.packageCode)) {
          setIsAgainstPkg(true);
        }
        setRfqDetails(res.data?.data);
        setRfqDetailsClone(res.data?.data);
        
        getRFQFieldDetails(res.data?.data); 

        // setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getRFQVendorDetails = (param) => {
    setIsLoading(true);
    let data = `/${param}`;
    rfqServices.getRfqListing(data)
      .then((res) => {
        if (res.data.success === true) {
          let rfqrfqVendorsInit = _.cloneDeep(rfqDetails);
          rfqrfqVendorsInit['rfqVendors'] = res?.data?.data?.rfqVendors;
          setRfqDetails(rfqrfqVendorsInit);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const rfqValidityChange = (e) => {
    addIsAlertUnsavedData();
    let { name, value } = e.target;
    let rfqValidityInit = _.cloneDeep(rfqDetails?.rfqValidity);
    rfqValidityInit[name] = value;

    // Validation logic
    let validationError = false;
    let errorMessage = '';

    if (name === "from") {
      // Ensure "From" date is not earlier than today
      if (value < todayDate) {
        validationError = true;
        errorMessage = "From date cannot be earlier than today";
      }
      // Ensure "To" date is not earlier than "From" date
      if (rfqValidityInit.to && value > rfqValidityInit.to) {
        validationError = true;
        errorMessage = "From date cannot be later than To date";
      }
    } else if (name === "to") {
      // Ensure "To" date is not earlier than today
      if (value < todayDate) {
        validationError = true;
        errorMessage = "To date cannot be earlier than today";
      }
      // Ensure "To" date is not earlier than "From" date
      if (rfqValidityInit.from && value < rfqValidityInit.from) {
        validationError = true;
        errorMessage = "To date cannot be earlier than From date";
      }
    }

    // Handle validation error
    if (validationError) {
      // Reset the field to blank
      rfqValidityInit[name] = '';
      setRfqDetails((prevState) => ({
        ...prevState,
        rfqValidity: rfqValidityInit,
      }));
      setAlertComponent({ open: true, type: "error", message: errorMessage });
    } else {
      // Update state with validated rfqValidityInit
      setRfqDetails((prevState) => ({
        ...prevState,
        rfqValidity: rfqValidityInit,
      }));
    }
  }

  const onTextChange1 = (e) => {
    let { name, value } = e.target;
    addIsAlertUnsavedData();
    setRfqDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setRfqDetailsClone((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  const onTextChange = (e) => {
    const { name, value } = e.target; 
    addIsAlertUnsavedData();
    setRfqDetails((prevState) => { 
      if (prevState.hasOwnProperty(name)) {
        const updatedState = {
          ...prevState,
          [name]: value,
        }; 
        return updatedState;
      } 
      if (prevState.additionalFields && prevState.additionalFields.hasOwnProperty(name)) {
        const updatedState = {
          ...prevState,
          additionalFields: {
            ...prevState.additionalFields,
            [name]: value,   
          },
        }; 
        return updatedState;
      } 
      const updatedState = {
        ...prevState,
        additionalFields: {
          ...(prevState.additionalFields || {}),
          [name]: value,  // update the specific field
        },
      }; 
      return updatedState;
    });
  };

  const getRateDataByRound = (row, roundId) => {
    if (isEmptyDash(row?.rateData)) {
      //return { rate: 0 };
      return null;
    } else {
      let obj = null;
      for (let i = 0; i < row?.rateData.length; i++) {
        if (row?.rateData[i]?.round == roundId) {
          obj = row?.rateData[i];
        }
      }
      return obj;
    }
  }

  const getValidate = (param1 , param2) =>{ 
    if(isEmptyDash(param1?.value?.response)){
      return param1?.response;
    }else{
      return param1?.value?.response;
    }
  }
  const handleClick = (document, index, secName) => { 
  
    const documentData = {
      name: document.name,   
     // response: isEmptyDash(rfqDetails?.packageCode ) ? getValidate(document) :  document?.value?.response ,
     response:document?.value?.response,
      uniqueName : document?.uniqueName,
      secName
    };   
    
    if(rfqDetails?.rfqNumber?.startsWith('TEMP')){ 
      setUploadFilesObj(documentData); 
    }else{
      setUploadFilesObj(documentData);
    } 
    setIsMediaListModalOpen(true);
  }

  const handleButtonClick = (i) => {
    fileInputRef.current[i].click();
  
  };

  const handlePackageButtonClick = (i)=>{
    filePackageInputRef.current[i].click();
   
  }
  const handleRFQButtonClick = (i) =>{
    fileRFQInputRef.current[i].click();
  }

  const uploadFile = (e, document, index,docType) => { 
    e.preventDefault();
    addIsAlertUnsavedData();
    let formData = new FormData();
    let files = e.target.files[0]
    const documentName = e.target?.dataset?.documentname;
    const uniqueName = e.target?.dataset?.uniquename;
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          setUrl(response?.data?.data, files, document, index , docType);
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
        // openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

 

  const handleAddRow = () => {
    const newRow = {
      "description": "",
      "hsnSacCode": "",
      "uom": "",
      "quantity": null,
      // "rate": null,
      // "amount": null,
    };

    let boqInit = _.cloneDeep(rfqDetails?.boqs);
    setRfqDetails((prevState) => ({
      ...prevState,
      boqs: [...boqInit, newRow]
    }));

  };

  const handleInputChange = (e, row, i, roundId) => {
    const { name, value } = e.target;
    let boqInit = _.cloneDeep(rfqDetails?.boqs);
    addIsAlertUnsavedData(); 
    // Prevent negative values for both "quantity" and "rate"
    if ((name === "quantity" || name === "rate") && Number(value) < 0) {
      return;
    }

    // Handle changes to the "rate" field
    if (name === "rate") {
      // Allow backspace to clear the field and display an empty input
      const updatedRate = value === "" ? "" : Number(value); 

      for (let index = 0; index < boqInit[i]["rateData"].length; index++) {
        if (boqInit[i]?.rateData[index]?.round === roundId) {
          boqInit[i].rateData[index].rate = updatedRate; // Allow empty string or the number
          boqInit[i].rateData[index].amount = updatedRate === "" ? 0 : updatedRate * boqInit[i]["quantity"]; // Calculate amount only when the rate is a number
        }
      }
    } else {
      boqInit[i][name] = value;
    }

    // Update the state
    setRfqDetails((prevState) => ({
      ...prevState,
      boqs: [...boqInit],
    }));
  };

  const handleInputRejectChange = (value, index) => {
    let arr = _.cloneDeep(initiateObjR2?.Rejected);
    arr[index].remarks = value;

    setInitiateObjR2((prevState) => ({
      ...prevState,
      Rejected: [...arr]
    }));
  };

  const editHsnCode = (e, row, i) => {
    // const { name, value } = e.target;
    if (isEditRFQ == true) {
      let boqInit = _.cloneDeep(rfqDetails?.boqs);
      boqInit[i]["isEdit"] = true;

      setRfqDetails((prevState) => ({
        ...prevState,
        boqs: [...boqInit]
      }));
    }
  };
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({ id: null, index: null });
  const [syncedData, setSyncedData] = useState([]);
  const [activeProjectFields, setactiveProjectFields] = useState('');
  const[activeDocument, setActiveDocument] = useState([]);
  const[activeRFQDocument, setActiveRFQDocument] = useState([]);
  const[activefields, setActiveFields] = useState([]);

  const confirmDelete = (i) => {
    setDeleteTarget({ id, index: i });
    setShowDeleteConfirmation(true);
  };


  const handleDeleteConfirm = async () => {
    const { index } = deleteTarget;
    // deleteRow(index);
    // openAlert(true, "success", `Line item Deleted Successfully`);
    const response = await deleteRow(index); 
    if (response) {
        openAlert(true, "success", "Line item Deleted Successfully"); 
    } 
    setShowDeleteConfirmation(false);
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirmation(false);
  };


  const deleteRow = (i) => {
    let boqInit = _.cloneDeep(rfqDetails?.boqs);
    if (isEmptyDash(boqInit[i]?._id)) {
      const updatedRows = boqInit.filter((row, idx) => i !== idx);
      setRfqDetails((prevState) => ({
        ...prevState,
        boqs: [...updatedRows]
      }));

    } else {
      if (!isEmptyDash(rfqDetails?.packageCode)) {
        setAlertComponent({
          open: true,
          type: 'error',
          message: `Cannot delete BOQ items.`,
        });
        return;
      }
      setIsLoading(true);
      rfqServices.deleteBOQ(id, boqInit[i]?._id)
        .then((res) => {
          if (res.data.success === true) {
            const updatedRows = boqInit.filter((row, idx) => i !== idx);
            setRfqDetails((prevState) => ({
              ...prevState,
              boqs: [...updatedRows]
            }));
            setRfqDetailsClone((prevState) => ({
              ...prevState,
              boqs: [...updatedRows]
            }));
          } else {
            setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
          }
        })
        .catch(function (error) {
          setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }

  };


  const [selectedVendorIds, setSelectedVendorIds] = useState({});

  const handleCheckboxChange = (vendorId, isChecked, page) => {
    setSelectedVendorIds(prevState => {
      const updatedState = { ...prevState };
      if (!updatedState[page]) {
        updatedState[page] = new Set();
      }
      if (isChecked) {
        updatedState[page].add(vendorId);
      } else {
        updatedState[page].delete(vendorId);
      }
      return updatedState;
    });
  };

  const submitExistingVendorId = (param) => {
    const allSelectedVendorIds = Object.values(selectedVendorIds).reduce((acc, set) => {
      return acc.concat(Array.from(set));
    }, []);

    extendVendor(param, allSelectedVendorIds);
  }

  const extendVendor = (param, vendorArr) => {
    setIsLoading(true);

    let bodyData = {
      "isSubmitting": param, // true for Created
      "isExtendedVendor": true, //for extending vendors after submitting rfq
       "purchaseType": rfqDetailsClone?.purchaseType,
      "remarks": rfqDetailsClone?.remarks,
      // "rfqValidity": rfqDetailsClone?.rfqValidity,
      // "vendorIds": ["66585701a115961624b0d6ad"],
      "vendorIds": vendorArr,
      // "boqs": rfqDetailsClone?.boqs,
      // "documents": rfqDetailsClone?.documents,
    }


    rfqServices?.updateRFQ(id, bodyData)
      .then((res) => {
        if (res.data.success === true) {
          // setPackageDetailCreationlist(res.data.data);
          getRFQVendorDetails(id);
          // setOpenBoqUpdateSuccessfully(false);
          setCreatedNewRFQNo(`${res.data?.data?.rfqNumber} `)
          setAlertComponent({ open: true, type: "success", message: `${res.data?.message} `, });
          setCreateVendorOpen(false);
          setexistingVendor(false);
          // navigateUrl(`/admin/Project-Manager-Packages-Listing`);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  const transformDocuments = (document) => {   
    return document.map((field) => ({
      documentName: field.name,
      uniqueName: field.uniqueName,
      response: field?.value?.response ? field?.value?.response.map((res) => ({
        acknowledged: res?.acknowledged,
        vendorResponse : res?.vendorResponse,
        key: res.key,
        fileName: res.fileName,
        _id: res?._id, 
      })) : [],  
      _id: field?.value?._id, 
    }));
   
    // if(rfqDetails?.rfqNumber?.startsWith('TEMP')){
    //       const mapResponse = (field) => {
    //         const responses = field?.response || field?.value?.response || [];  
    //         return responses.map((res) => ({
    //             acknowledged: res?.acknowledged,
    //             key: res.key,
    //             fileName: res.fileName,
    //             _id: field?.value?._id,  
    //         }));
    //     };
    //     return document.map((field) => ({
    //       documentName: field.name,
    //       uniqueName: field.uniqueName,
    //       // response: field?.response ? field?.response.map((res) => ({
    //       //   acknowledged: res?.acknowledged,
    //       //   key: res.key,
    //       //   fileName: res.fileName,
    //       //   _id: field?.value?._id,
    //       // })) : [],  
    //       response: mapResponse(field),
    //       _id: field?.value?._id,  
    //     })); 

    // }else{ 

    //   return document.map((field) => ({
    //     documentName: field.name,
    //     uniqueName: field.uniqueName,
    //     response: field?.value?.response ? field?.value?.response.map((res) => ({
    //       acknowledged: res?.acknowledged,
    //       vendorResponse : res?.vendorResponse,
    //       key: res.key,
    //       fileName: res.fileName,
    //       _id: field?.value?._id, 
    //     })) : [],  
    //     _id: field?.value?._id, 
    //   }));


    // }
   
  };

  const areAllRequiredFieldsAndDocumentsValid = () => {
    const validateItems = (items, type) => {
      for (let item of items) {
        if (
          !item.response || 
          item.response.length === 0 || 
          !item.response[0].fileName
        ) {
          return { valid: false, label: item.name || `Unnamed ${type}` }; // Fallback for missing name
        }
      }
      return { valid: true };
    };  
      if (!rfqDetails.purchaseType || rfqDetails.purchaseType.trim() === "") {
        return { valid: false, label: 'Purchase Type' || "Unnamed Field" };  
      } 
  
    // Step 2: Validate active package documents
    const packageValidation = validateItems(activeDocument, "Package Document");
    if (!packageValidation.valid) return packageValidation;
  
    // Step 3: Validate active RFQ documents
    const rfqValidation = validateItems(activeRFQDocument, "RFQ Document");
    if (!rfqValidation.valid) return rfqValidation;
  
    return { valid: true };  
  };
  
 

  const submitForm = (param) => { 
     setIsLoading(true);
    setEditSubmitStatus(param);
    if (rfqDetails?.purchaseType === '' || rfqDetails?.purchaseType === undefined) {
      setAlertComponent({ open: true, type: "error", message: "Please select Purchase Type" });
      setIsLoading(false);
      return;
    }
    /** Check BOQ */
    if (param === true) {
      const validateTableData = () => {
        for (const row of rfqDetails?.boqs) {
          if (row.quantity === 0) {
            return { valid: false, message: "Quantity should not be zero" };
          }
          if (!row.description || !row.hsnSacCode || !row.uom || !row.quantity || row.quantity === undefined || row.quantity === null) {
            return { valid: false, message: "Please fill the blank BOQ line item first to proceed" };
          }
        }
        return { valid: true };
      };
      const boqValidation = validateTableData();
      if (!boqValidation.valid) {
        setAlertComponent({ open: true, type: "error", message: boqValidation.message });
        setIsLoading(false);
        return;
      }

      if (!rfqDetails?.rfqValidity?.from || !rfqDetails?.rfqValidity?.to) {
        setAlertComponent({ open: true, type: "error", message: "RFQ validity is a required field" });
        setIsLoading(false);
        return;
      }
    }

    /** check existing vendor */
    // if (vendorTableDataArr.length === 0) {
    //   setAlertComponent({ open: true, type: "error", message: "Please Select at least one Existing Vendors" });
    //   setIsLoading(false);
    //   return;
    // }

    // let bodyData = _.cloneDeep(createPackageFieldsDetails);
 
      const allFields = activeProjectFields
      .filter((section) => section.title === "Fields")
      .flatMap((section) => section.fields);  
      const dynamicFields = allFields.filter((field) => !field.static);  
      const additionalFields = dynamicFields.reduce((obj, field) => { 
        if (rfqDetails.additionalFields && rfqDetails.additionalFields[field.uniqueName]) {
          obj[field.uniqueName] = rfqDetails.additionalFields[field.uniqueName];  
        }
        return obj;
      }, {}); 
      const filteredFormData = Object.keys(rfqDetails)
      .filter((key) => !dynamicFields.some((field) => field.uniqueName === key))
      .reduce((obj, key) => {
        obj[key] = rfqDetails[key];
        return obj;
      }, {}); 
    const DocArray = [...activeRFQDocument, ...activeDocument]; 
    let bodyData = {
      "isSubmitting": param, // true for Created
      "isExtendedVendor": false, //for extending vendors after submitting rfq
      "purchaseType": rfqDetails?.purchaseType,
      "remarks": rfqDetails?.remarks,
      "rfqValidity": rfqDetails?.rfqValidity,
      "vendorIds": [],
      "boqs": rfqDetails?.boqs,
      "documents": transformDocuments(DocArray),
      "additionalFields": additionalFields 
    }   
    if (userRole == "VENDOR") {
      delete bodyData.isExtendedVendor;
      delete bodyData.purchaseType;
      delete bodyData.remarks;
      delete bodyData.rfqValidity;
      delete bodyData.vendorIds;


      if (statusArr.indexOf(rfqDetails?.status) > 10) {
        bodyData["roundId"] = 2;
        for (let i = 0; i < bodyData.boqs.length; i++) {
          bodyData.boqs[i].rate = bodyData.boqs[i].rateData[1].rate;
        }
      } else {
        bodyData["roundId"] = 1;
        for (let i = 0; i < bodyData.boqs.length; i++) {
          bodyData.boqs[i].rate = bodyData.boqs[i].rateData[0].rate;
        }
      }

      rfqServices?.updateVendorRFQ(id, bodyData)
        .then((res) => {
          if (res.data.success === true) {
            // setPackageDetailCreationlist(res.data.data);
            setOpenBoqUpdateSuccessfully(true);
            setCreatedNewRFQNo(`${res.data?.data?.rfqNumber} `)
            // setAlertComponent({ open: true, type: "success", message: `${res.data?.message} `, });
            // navigateUrl(`/admin/Project-Manager-Packages-Listing`);
          } else {
            setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
          }
        })
        .catch(function (error) {
          setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
        })
        .finally((param) => {
          setIsLoading(false);
        });

    } else {
      rfqServices?.updateRFQ(id, bodyData)
        .then((res) => {
          if (res.data.success === true) {
            // setPackageDetailCreationlist(res.data.data);
            setOpenBoqUpdateSuccessfully(true);
            setCreatedNewRFQNo(`${res.data?.data?.rfqNumber} `)
            // setAlertComponent({ open: true, type: "success", message: `${res.data?.message} `, });
            // navigateUrl(`/admin/Project-Manager-Packages-Listing`);
          } else {
            setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
          }
        })
        .catch(function (error) {
          setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
        })
        .finally((param) => {
          setIsLoading(false);
        });

    }
  }


  const reloadChanges = (param) => {
    window.location.reload();
  }

  const cancelRFQ = () => {
    setIsLoading(true);
    rfqServices
      .deleteRFQ(id)
      .then((res) => {
        if (res.data.success === true) {
          navigateUrl(`/admin/Engineering-Bidding-Rfq-Listing`);
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'Unable to delete.', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const navigateUrl = (param) => {
    navigate(param);
  }; 
  const setOpenRfqExitingVenodr = () => {
    setexistingVendor(true);
  }
  const closeExitingVendorModal = () => {
    setexistingVendor(false);
  };

  // useEffect(() => {
  //   if (secRFQPermission?.EXTEND_VENDOR?.update == true) {
  //     // getExistingVendorRfqList(requestPayload);
  //   }
  // }, [requestPayload]);

  const getExistingVendorRfqList = (requestPayloadParam, filterTextParam) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    rfqServices
      .getExistingVendorRfqListing(param)
      .then((res) => {
        if (res && res.data) {
          setexistingVendorDataList(res.data)
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'No Data Found', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  const downloadVendorRFQ = (param) => {
    setIsLoading(true);

    let bodyData = {
      "rfqId": id,
    };
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");

    let raw = JSON.stringify(bodyData);

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${urlConstants.BASE_URI_DEV}/v1/vendor/rfqs/download-documents`,
      requestOptions
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "vendorRFQ.zip";
        document.body.appendChild(a);
        a.click(); // Simulate click
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading blob:", error);
      })
      .finally((param) => {
        setIsLoading(false);
      });

  };

  const techComEvaluation = (param, param2) => {
    setIsLoading(true);
    let bodyData = {
      "type": param,
      "round": param2,
    };
    rfqServices
      .initiateEvaluation(id, bodyData)
      .then((res) => {
        if (res.data.success === true) {
          if (param2 == 1) {
            if (param == "Technical") {
              navigateUrl(`/admin/Engineering-Bidding-Technical-Evaluation/${id}`);
            }
            if (param == "Commercial") {
              navigateUrl(`/admin/Buyer-Bidding-Commercial-Comparision-Round-1/${id}`);
            }
          } else if (param2 == 2) {
            navigateUrl(`/admin/Engineering-Bidding-Rfq-Listing`);
          }

          // setexistingVendorDataList(res.data)
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'No Data Found', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });

    // if (rfqDetails?.status == "Published") {

    // } else if (rfqDetails?.status == "Technical_Evaluation_In_Progress") {
    //   navigateUrl(`/admin/Engineering-Bidding-Technical-Evaluation/${id}`);
    // }
  };

  const isComEvaluation = (param) => { 
    let str = false;
    if (rfqDetails?.rfqType == "ONE_BID") {
      if (param == "Initiate" && (statusArr.indexOf(rfqDetails?.status) == 6)) {
        str = true;
      }
      if (param == "Comparison" && (statusArr.indexOf(rfqDetails?.status) > 6)) {
        str = true;
      }
    } else {
      if (rfqDetails?.approvalFlow == "Linear") {
        if (param == "Initiate" && (statusArr.indexOf(rfqDetails?.status) == 8)) {
          str = true;
        }
        if (param == "Comparison" && (statusArr.indexOf(rfqDetails?.status) > 8)) {
          str = true;
        }
      }
 
      if (rfqDetails?.approvalFlow == "Simultaneous") {
        if (param == "Initiate" && (statusArr.indexOf(rfqDetails?.status)  == 8)) {
          str = true;
        }
        if (param == "Comparison" && (statusArr.indexOf(rfqDetails?.status) > 8)) {
          str = true;
        }
      }
    }

    return str;
  }
 

  const isTechEvaluation = (param) => {
    let str = false; 
    if (rfqDetails?.approvalFlow == "Linear") {
      if (param == "Initiate" && (statusArr.indexOf(rfqDetails?.status) == 6)  ) {
        str = true;
      }
      if (param == "Comparison" && (statusArr.indexOf(rfqDetails?.status) > 6)) {
        str = true;
      }
    }

    if (rfqDetails?.approvalFlow == "Simultaneous") {
      if (param == "Initiate" && rfqDetails?.technicalStatus == "Pending" && (statusArr.indexOf(rfqDetails?.status) >= 6)) {
        str = true;
      }
      if (param == "Comparison" && rfqDetails?.technicalStatus != "Pending" && (statusArr.indexOf(rfqDetails?.status) > 6)) {
        str = true;
      }
    }
    return str;
  }

  const handleCheckboxInitR2 = (e, data, index) => {
    const { checked } = e.target;
    const vendorTableDataArrInit = _.cloneDeep(vendorTableDataArr);
    vendorTableDataArrInit[index].isChecked = checked;
    setVendorTableDataArr(vendorTableDataArrInit);
  };


  const initiateR2 = () => {
    let bodyData = {
      "roundId": 2,
      "vendors": [],
    };
    let initiateObjR2 = {
      "Approved": [],
      "Rejected": [],
    };
    let approvedVendors;
    if (rfqDetails?.rfqType === 'ONE_BID') {
      approvedVendors = vendorTableDataArr;
    } else {
      approvedVendors = vendorTableDataArr.filter(vendor => vendor.technicalEvaluationStatus === "Approved");
    }
    for (let i = 0; i < approvedVendors.length; i++) {
      let obj = {
        "vendorId": approvedVendors[i]?._id,
        "remarks": "",
        "status": ""
      };
      if (approvedVendors[i]?.isChecked == true) {
        obj["status"] = "Approved";
        obj["remarks"] = "";
        obj["vendorName"] = approvedVendors[i]?.vendorName;
        initiateObjR2.Approved.push(obj);
      }
      else {
        obj["status"] = "Rejected";
        obj["remarks"] = "";
        // obj["vendorName"] = vendorTableDataArr[i]?.vendorName;
        obj["vendorName"] = approvedVendors[i]?.vendorName;
        initiateObjR2.Rejected.push(obj);
      }
      bodyData.vendors.push(obj);
    }
    if (initiateObjR2.Approved.length < 1) {
      setAlertComponent({ open: true, type: "error", message: `Please select at least one vendor to proceed to Round 2. ` });
      return;
    }


    if (initiateObjR2.Rejected.length > 0) {
      setIsRejectListModalOpen(true);
      setInitiateObjR2(initiateObjR2);
    } else {
      initiateR2Api(bodyData);
    }

  };

  const submitRejectVendorR2 = () => {
    let bodyData = {
      "roundId": 2,
      "vendors": [...initiateObjR2?.Approved, ...initiateObjR2?.Rejected],
      // "vendors": [...initiateObjR2?.Approved],
    };
    initiateR2Api(bodyData);
  }
  const initiateR2Api = (bodyData) => {
    let promise = rfqServices.initiateRound2(id, bodyData);
    promise.then((res) => {
      if (res.data.success === true) {
        techComEvaluation("Commercial", 2);
        setOpenSelectRoundTwoRfqDetailModal(true);
        setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const commercialNavigateUrl = (param) => {
    // if ((statusArr.indexOf(rfqDetails?.status) > 9)) {
    if (rfqDetails?.activeRound?.roundId === 1) {
      navigateUrl(`/admin/Buyer-Bidding-Commercial-Comparision-Round-1/${id}`);
    } else {
      navigateUrl(`/admin/Buyer-Bidding-Commercial-Comparison/${id}`);
    }
  };

  const getTotalByRound = (roundId) => {
    let obj = {
      [`totalRate${roundId}`]: 0,
      [`totalAmount${roundId}`]: 0,
    };

    for (let index = 0; index < rfqDetails?.boqs.length; index++) {
      for (let i = 0; i < rfqDetails?.boqs[index]?.rateData.length; i++) {
        if (rfqDetails?.boqs[index]?.rateData[i]?.round == roundId) {
          obj[`totalRate${roundId}`] += Number(rfqDetails?.boqs[index]?.rateData[i]?.rate);
          obj[`totalAmount${roundId}`] += Number(rfqDetails?.boqs[index]?.rateData[i]?.amount);
          // obj["totalRate2"] += Number(rfqDetails?.boqs[index]?.rateData[i]?.rate);
          // obj["totalAmount2"] += Number(rfqDetails?.boqs[index]?.rateData[i]?.rate);
        }
      }
    }
    return obj;
  };

  const isValidatityExpired = () => {
    const validity = rfqDetails?.rfqValidity?.to; 
    if (!validity) { 
      return false; // Assuming it's not expired if no validity date is provided
    }
  
    const validityDate = new Date(validity); // Convert to Date object
    const currentDate = new Date(); // Get current date
  
    // Check if the validity date is earlier than the current date
    if (validityDate < currentDate) { 
      return true; // Expired
    } else { 
      return false; // Not expired
    }
  };

  const isEditButtonPermission = () => { 
    if (userRole === "BUYER" && statusArr.indexOf(rfqDetails?.status) < 3 && isEditRFQ == false) {
     // if (userRole === "BUYER"  && isEditRFQ == false) {
      return true;
    }
    if (userRole === "ENGINEER") {
      return false;
    }
    if (userRole === "VENDOR" && isEditRFQ == false && rfqDetails?.vendorActiveRound?.participationStatus !== "Pending_To_Participate" && rfqDetails?.vendorActiveRound?.participationStatus !== "Rejected" && rfqDetails?.isExpired === false ) {
      return true;
    }
    return false;
  };

  const handleEditClick = (rowIndex) => {
    if (rfqDetails && rfqDetails.boqs && rowIndex >= 0 && rowIndex < rfqDetails.boqs.length) {
      setEditRowIndex(rowIndex);
      setModalDescription(rfqDetails.boqs[rowIndex].description);
      setIsModalOpen(true);
    } else {
    }
  };
  const handleModalSubmit = () => {
    if (editRowIndex !== null && rfqDetails && rfqDetails.boqs) {
      const updatedData = [...rfqDetails.boqs];
      if (editRowIndex >= 0 && editRowIndex < updatedData.length) {
        updatedData[editRowIndex].description = modalDescription;
        setRfqDetails({ ...rfqDetails, boqs: updatedData });
        setEditRowIndex(null);
        setIsModalOpen(false);
      } else {
      }
    } else {
    }
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [evaluationType, setEvaluationType] = useState(null);

  const handleEvaluationButtonClick = (type) => {
    setEvaluationType(type);
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    if (evaluationType) {
      techComEvaluation(evaluationType, 1);
    }
    setShowConfirmation(false);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };
  function formatFileName(fileName, maxLength = 15) {
    if (!fileName || typeof fileName !== 'string') {
      return '';
    }
    if (fileName.length <= maxLength) {
      return fileName;
    }
    const startLength = Math.ceil(maxLength / 2);
    const endLength = Math.floor(maxLength / 2) - 3;

    const startText = fileName.substring(0, startLength);
    const endText = fileName.substring(fileName.length - endLength);

    return `${startText}...${endText}`;
  }

  const [deleteVedId, setDeleteVedId] = React.useState({});
  const [deleteiconopen, setdeleteiconopen] = React.useState(false);

  const closeDeleteModal = () => {
    setDeleteVedId({});
    setdeleteiconopen(false);
  };
  const openDeleteModal = (vendId) => {
    setDeleteVedId(vendId);
    setdeleteiconopen(true);
  };

  const confirmDeleteModal = () => {
    setIsLoading(true);
    let bodyData = { "vendorId": deleteVedId };
    let promise = rfqServices.deleteVendor(rfqDetails?._id, bodyData);
    promise.then((res) => {
      if (res.data.success === true) {
        setVendorTableDataArr((prevData) =>
          prevData.filter((vendor) => vendor.vendorId !== deleteVedId)
        );
        setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
        setTimeout(() => { window.location.reload(); }, 2000)
        setdeleteiconopen(false);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });

  };



  const [prNumberDisabled, setPrNumberDisabled] = useState([]);
  const [prSaveButtonDisabled, setPrSaveButtonDisabled] = useState(false);

  useEffect(() => {
    if (
      userRole === 'BUYER' &&
      rfqDetails?.rfqNumber?.startsWith('RFQ') &&
      rfqDetails?.boqs?.length &&
      prNumberDisabled.length === 0
    ) {
      const initialDisabledState = rfqDetails.boqs.map(() => true);
      setPrNumberDisabled(initialDisabledState);
    }
  }, [userRole, rfqDetails, prNumberDisabled.length]);

  const handlePRNumberChange = (id, key, value, index) => {
    const updatedBOQ = _.cloneDeep(rfqDetails?.boqs);
    addIsAlertUnsavedData();
    updatedBOQ[index][key] = value;
    setRfqDetails((prevState) => ({
      ...prevState,
      boqs: updatedBOQ,
    }));
    handlePRNumberInputChange(value, index);
  };
  const handlePRNumberInputChange = (value, index) => {
    const updatedDisabledState = [...prNumberDisabled];
    addIsAlertUnsavedData();
    updatedDisabledState[index] = false;
    setPrNumberDisabled(updatedDisabledState);
  };

  const enableBlankPRNumberFields = () => {
    const updatedDisabledState = prNumberDisabled?.map((isDisabled, index) => {
      return rfqDetails.boqs[index].prNumber === '' || rfqDetails.boqs[index].prNumber === undefined
        ? false
        : true;
    });
    setPrNumberDisabled(updatedDisabledState);
    setPrSaveButtonDisabled(true);
  };



  const savePrNo = () => {
    setIsLoading(true);
    const existingPrNumbers = new Set(initialBoqs.map(boq => boq.prNumber ? boq.prNumber.trim() : ''));
    const updatedBoqs = rfqDetails?.boqs
      .filter(boq => boq.prNumber && boq.prNumber.trim() !== '' && !existingPrNumbers.has(boq.prNumber.trim()))
      .map(boq => ({
        boqId: boq._id,
        prNumber: boq.prNumber.trim()
      }));
    if (updatedBoqs.length === 0) {
      openAlert(true, "error", "No new PR numbers to update.");
      setIsLoading(false);
      return;
    }
    const payload = { boqs: updatedBoqs };
    packageServices
      .addPRNumber(id, payload, 'rfqs')
      .then((res) => {
        if (res.data.success === true) {
          openAlert(true, "success", res.data.message);
          setTimeout(() => {
            navigateUrl(`/admin/Engineering-Bidding-Rfq-Listing`);
          }, 1000);
        } else {
          setIsLoading(false);
          openAlert(true, "error", `${res?.data?.data?.message}`);
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  
  const [openDefaulfFields, setOpenDefaulfFields] = React.useState(false);
  const [openBulkUploadModal, setOpenBulkUploadModal] = React.useState(false);
  const [createTableArr, setCreateTableArr] = useState([]);

  const onBulkUploadSubmit = (fileDataParam, createTableArr) => {
    addIsAlertUnsavedData();
    let isAllFieldsMapped = true;
    let updatedTableArr = [...createTableArr];
  
    // Validate dropdown mapping
    for (let i = 0; i < updatedTableArr.length; i++) {
      if (!updatedTableArr[i].value) {
        updatedTableArr[i].errMsg = "Please select a value from the drop-down";
        isAllFieldsMapped = false;
      } else {
        updatedTableArr[i].errMsg = "";
      }
    }
  
    if (!isAllFieldsMapped) {
      setCreateTableArr(updatedTableArr);
      openAlert(true, "error", `Please select values from the drop-down for each field.`);
      return;
    }
  
    let reader = new FileReader();
  
    reader.onload = function (e) {
      let data = e.target.result;
      data = new Uint8Array(data);
      let workbook = XLSX.read(data, { type: "array" });
      let result = {};
  
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
          defval: "" // Ensure empty cells are represented as empty strings
        });
        if (roa.length) result[sheetName] = roa;
      }); 
  
      let obj = {};
      let updatedTableData = [...rfqDetails.boqs]; // Copy existing table data 
  
      // Map column indices to table fields
      for (let i = 0; i < createTableArr.length; i++) {
        let valIndex = result?.Sheet1[0]?.indexOf(createTableArr[i].value);
        let keyName = createTableArr[i].name;
        obj[keyName] = valIndex;
      } 
  
      let rowIndex = 0; // Track current row index for replacement
  
      // Process Excel data rows
      for (let j = 1; j < result?.Sheet1.length; j++) {
        let row = result.Sheet1[j];
        let newRow = {};
  
        // Build new row from Excel data
        for (let key in obj) {
          newRow[key] = row[obj[key]] || ""; // Default empty if undefined
        } 
  
        // Replace blank rows or append new rows
        if (
          rowIndex < updatedTableData.length &&
          Object.values(updatedTableData[rowIndex]).every((value) => value === "" || value === null)
        ) { 
          updatedTableData[rowIndex] = newRow;
        } else { 
          updatedTableData.push(newRow);
        }
  
        rowIndex++;
      } 
  
      // Update the BOQs in state
      setRfqDetails((prevState) => ({
        ...prevState,
        boqs: updatedTableData
      })); 
  
      onsetOpenDefaulfFields(false);
    };
  
    reader.readAsArrayBuffer(fileDataParam);
  };
  
  


  const onsetOpenDefaulfFields = (param) => {
    setOpenDefaulfFields(param);
  };

 
  
  const [filterText, setFilterText] = useState(""); 
  const [filteredRows, setFilteredRows] = useState([]);

  //  const debouncedSearch = useCallback(
  //   _.debounce((searchTerm) => { 
  //     const rows = getFilteredRows();
  //     setFilteredRows(rows); 
  //   }, 800),
  //   []
  // );
  const getFilteredRows = () => {
    return filterText
      ? rfqDetails?.boqs.filter(row =>
          row.description.toLowerCase().includes(filterText.toLowerCase()) ||
          row.hsnSacCode.toLowerCase().includes(filterText.toLowerCase()) ||
          row.prNumber?.toLowerCase().includes(filterText.toLowerCase()) ||
          row.uom.toLowerCase().includes(filterText.toLowerCase()) ||
          String(row.quantity).toLowerCase().includes(filterText.toLowerCase())
        )
      : rfqDetails?.boqs;  // If no search text, show all rows
  };
  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value); 
    // debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => { 
    const rows = getFilteredRows();
    setFilteredRows(rows);
  };

 

  // Reset filtered rows when rfqDetails changes
  useEffect(() => {
    if (rfqDetails?.boqs) {
      setFilteredRows(rfqDetails?.boqs);  // Set rows when rfqDetails changes
    }
  }, [rfqDetails]);
  // const [activeProjectFields, setactiveProjectFields] = useState('');
  // const[activeDocument, setActiveDocument] = useState([]);
  // const[activefields, setActiveFields] = useState([]);

  const getRFQFieldDetails = (detailsResData) => {
    setIsLoading(true); 
    rfqServices
      .getRfqFieldList('BIDDING','RFQ')
      .then((res) => { 
        if (res.data.success === true) { 
            const filteredDocument = res.data?.data?.sections.filter(section => { 
              return section.title === "Package_Documents";
            });
            const filteredFields = res.data?.data?.sections.filter(section => { 
              return section.title === "Fields";
            });
            const filteredRFQDocument = res.data?.data?.sections.filter(section => { 
              return section.title === "RFQ_Documents";
            }); 
            setActiveFields(filteredFields);
            setActiveDocument(filteredDocument); /** Package Document */
            setActiveRFQDocument(filteredRFQDocument);
            setactiveProjectFields( res.data?.data?.sections);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message} `,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };  
 
  const setUrl = (data, files, document, index,docType) => {
    let activeDocumentList = [];
    if(docType === 'RFQ_doc'){
       activeDocumentList = _.cloneDeep(activeRFQDocument);
    }else{
       activeDocumentList = _.cloneDeep(activeDocument);
    } 
    if (activeDocumentList.length) {
      for (let i = 0; i < activeDocumentList?.length; i++) {  
        if (activeDocumentList[i]?.uniqueName === document) {
          activeDocumentList[i].response = activeDocumentList[i].response || [];
          const fileObj = {
            key: encodeKey(data?.data?.Key),
            fileName: files?.name,
          }; 
          activeDocumentList[i]?.value?.response.push(fileObj);

          // if (rfqDetails?.rfqNumber?.startsWith("TEMP")) {
          //   activeDocumentList[i].response.push(fileObj);
          // } else {
          //   activeDocumentList[i]?.value?.response.push(fileObj);
          // }

        }
      }
    }  
    if (docType === 'RFQ_doc') { 
      setActiveRFQDocument(activeDocumentList);
    } else {
      setActiveDocument(activeDocumentList);
    }
  };
//   const setUrl = (data, files, document, index) => {      
//     let activeDocumentInitial = _.cloneDeep(activeDocument);   
//     if (activeDocumentInitial.length) {
//         for (let i = 0; i < activeDocumentInitial?.length; i++) { 
//             if (activeDocumentInitial[i]?.uniqueName === document) {                 
//               activeDocumentInitial[i].response = 
//                     activeDocumentInitial[i].response || [];
//                 let fileObj = {
//                     key: encodeKey(data?.data?.Key),
//                     fileName: files?.name,
//                     // id: data.data.id
//                 };
//                 if(rfqDetails?.rfqNumber?.startsWith('TEMP')) {
//                   activeDocumentInitial[i].response.push(fileObj); 
//                 }else{
//                   activeDocumentInitial[i]?.value?.response.push(fileObj); 
//                 }
                
//             }
//         }
//     } else {
         
//     }    
//     setActiveDocument(activeDocumentInitial); 
// };



 
  const syncData = () => {  
    const syncedFields = activefields?.flatMap((fieldGroup) => {
      if (Array.isArray(fieldGroup.fields)) {
        return fieldGroup.fields.map((field) => {
          const fieldValue =
          rfqDetails[field.uniqueName] ||
          rfqDetails?.additionalFields?.[field.uniqueName] ||
            "N/A";
  
          let displayValue = fieldValue;
  
          if (field.type === "Dropdown" && Array.isArray(field.options)) {
            const matchedOption = field.options.find(
              (option) =>
                String(option._id) === String(fieldValue) ||
                String(option.optionName).toLowerCase() === String(fieldValue).toLowerCase()
            );
  
            displayValue = matchedOption ? matchedOption.optionName : "N/A";
          }
  
          return { ...field, value: displayValue };
        });
      }
      return [];
    });
   
    const syncedPackageDocuments = activeDocument?.flatMap((docGroup) => {
      if (Array.isArray(docGroup.fields)) {
        return docGroup.fields.map((document) => { 
          const documentValue = rfqDetails.documents?.find(
            (doc) => doc.uniqueName === document.uniqueName
          ); 
          return {
            ...document,
            value: documentValue || "No Document Uploaded",
          };
        });
      }
      return [];
    });

    const syncedRFQDocuments = activeRFQDocument?.flatMap((docGroup) => {
      if (Array.isArray(docGroup.fields)) {
        return docGroup.fields.map((document) => { 
          const documentValue = rfqDetails.documents?.find(
            (doc) => doc.uniqueName === document.uniqueName
          ); 
          return {
            ...document,
            value: documentValue || "No Document Uploaded",
          };
        });
      }
      return [];
    });

    setActiveDocument(syncedPackageDocuments);  
    setActiveRFQDocument(syncedRFQDocuments);
    const combinedSyncedData = [...syncedPackageDocuments , ...syncedRFQDocuments]; 
    setSyncedData(combinedSyncedData); 
  };

  // useEffect(() => {
  //   getRFQFieldDetails(); 
  //   syncData();
  // }, [id]);

  useEffect(() => {
    if (activeProjectFields.length && Object.keys(rfqDetails).length) {
      syncData();
    }
  }, [activeProjectFields]);  
 
const deleteFile = (index, key, idx) => {
  if (!uploadFilesObj?.response || index < 0 || index >= uploadFilesObj.response.length) {
    console.error('Invalid index or response array.');
    return;
  } 
  const updatedFiles = uploadFilesObj.response.filter((_, i) => i !== index);  
  if(rfqDetails?.rfqNumber?.startsWith('TEMP')) {
    /** for RFQ creation */
      setActiveDocument(prevState => {
        const updatedState = _.cloneDeep(prevState);   
        if (Array.isArray(updatedState)) {
          for (let i = 0; i < updatedState.length; i++) {
            if (updatedState[i]?.uniqueName === uploadFilesObj?.uniqueName) {
              if (Array.isArray(updatedState[i].response)) {
                updatedState[i].response = updatedFiles;
              } else {
                updatedState[i].response = [];
              }
              break;
            }
          }
        } 
        return updatedState;
      }); 
      setActiveRFQDocument(prevState => {
        const updatedState = _.cloneDeep(prevState);   
        if (Array.isArray(updatedState)) {
          for (let i = 0; i < updatedState.length; i++) {
            if (updatedState[i]?.uniqueName === uploadFilesObj?.uniqueName) {
              if (Array.isArray(updatedState[i].response)) {
                updatedState[i].response = updatedFiles;
              } else {
                updatedState[i].response = [];
              }
              break;
            }
          }
        } 
        return updatedState;
      }); 
  }else{
    /** for details */
    setActiveDocument(prevState => {
      const updatedState = _.cloneDeep(prevState);   
      if (Array.isArray(updatedState)) {
        for (let i = 0; i < updatedState.length; i++) {
          if (updatedState[i]?.uniqueName === uploadFilesObj?.uniqueName) {
            if (Array.isArray(updatedState[i].value.response)) {
              updatedState[i].value.response = updatedFiles;
            } else {
              updatedState[i].value.response = [];
            }
            break;
          }
        }
      }  
      return updatedState;
    }); 
    setActiveRFQDocument(prevState => {
      const updatedState = _.cloneDeep(prevState);   
      if (Array.isArray(updatedState)) {
        for (let i = 0; i < updatedState.length; i++) {
          if (updatedState[i]?.uniqueName === uploadFilesObj?.uniqueName) {
            if (Array.isArray(updatedState[i].value.response)) {
              updatedState[i].value.response = updatedFiles;
            } else {
              updatedState[i].value.response = [];
            }
            break;
          }
        }
      }  
      return updatedState;
    }); 
  }


  setUploadFilesObj(prev => ({
    ...prev,
    response: updatedFiles,
  })); 
};

const calcDocPercent = () => {
  const docInit =  [...activeRFQDocument, ...activeDocument] ;  
  if (!Array.isArray(docInit) || docInit.length === 0) {
    return "0.00";  
  } 
  let num = '';
  if(rfqDetails?.rfqNumber?.startsWith('TEMP')){
      num = docInit.reduce((count, ele) => {
      if (ele?.response?.length > 0) {
        return count + 1;
      }
      return count;
    }, 0); 
  }else{
      num = docInit.reduce((count, ele) => {
      if (ele?.value?.response?.length > 0) {
        return count + 1;
      }
      return count;
    }, 0); 
  } 
  const percentage = (num / docInit.length) * 100;
  return percentage.toFixed(2);
};
   

// const deleteFile = (index, key, idx) => {
//   const rfqDetailsInit = _.cloneDeep(rfqDetails);
//   const updatedFiles = uploadFilesObj.response.filter((file, i) => i !== index);

//   for (let i = 0; i < rfqDetailsInit.documents.length; i++) {
//     if (rfqDetailsInit.documents[i].uniqueName == uploadFilesObj?.uniqueName) {
//       rfqDetailsInit.documents[i].response = [...updatedFiles];
//     }
//   }
//   setRfqDetails(rfqDetailsInit);
//   const obj = { ...uploadFilesObj, response: [...updatedFiles] };
//   setUploadFilesObj(obj);
// };

// const calcDocPercent = (param) => {
//    //let docInit = [...rfqDetails?.documents];
//   let docInit = activeDocument[0]?.fields;
//  console.log(activeDocument[0]?.fields);
//   let num = 0;
//   docInit.map((ele, i) => {
//     if (ele?.response.length > 0) {
//       num += 1;
//     }
//   });

//   let percentage = num * 100 / docInit.length;
//   return percentage.toFixed(2);
// };

  // const setUrl = (data, files, document, index) => {
  //   let rfqDetailsInitial = { ...rfqDetails };

  //   for (let i = 0; i < rfqDetailsInitial?.documents.length; i++) {
  //     if (rfqDetailsInitial?.documents[i]?.uniqueName == document?.uniqueName) {
  //       let fileObj = {
  //         key: encodeKey(data?.data?.Key),
  //         fileName: files?.name
  //       };
  //       rfqDetailsInitial?.documents[i]?.response.push(fileObj);
  //     }
  //   }
  //   setRfqDetails(rfqDetailsInitial);

  // };

  // useEffect(() => {
  //   if (rfqDetails && rfqDetails.additionalFields) {
  //     setRfqDetails((prevState) => ({
  //       ...prevState,
  //       additionalFields: prevState.additionalFields || {},
  //     }));
  //   }
  // }, [rfqDetails]);

  const addIsAlertUnsavedData = () => {
    let obj = {
      msg: `If confirm, all changes/updates will be discarded in the form. Please save draft or submit the document first before leaving this page.`,
      showAlert: true,
    }
    sessionStorage.setItem("isAlertUnsavedData", JSON.stringify(obj));
  }

  const vendorChatBoxClick = (vendorId) => {
    setActiveChatVendorId(vendorId);
    setIsVendorChatBoxOpen(true);  
  }
  const handleChatboxMinimize = () => {
    setIsVendorChatBoxOpen(false);
  }; 
  const [activeChatVendorId, setActiveChatVendorId] = useState("");
  const [isVendorChatBoxOpen, setIsVendorChatBoxOpen] = useState(false);

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerses1 ms-auto">
            <div className="search_main">
              <h5> {(rfqDetails && rfqDetails.rfqNumber && rfqDetails.rfqNumber.startsWith('TEMP'))
                ? 'RFQ Creation Form'
                : 'RFQ Details Form'}</h5>
            </div>
            <div class="timer_rfq_validity">
              <div>
                <label> Date: </label>
                <label> {strToDate(rfqDetails?.createdAt)}</label>
              </div>
              {(isEmptyDash(rfqDetails?.rfqValidity?.to)) && <div class="timer-container">
                <div class="timer-label">Timer</div>

                <div class="timer-box">
                  <div class="timer-number">0</div>
                  <div class="timer-text">days</div>
                </div>
                <div class="timer-box">
                  <div class="timer-number">0</div>
                  <div class="timer-text">hours</div>
                </div>
                <div class="timer-box">
                  <div class="timer-number">0</div>
                  <div class="timer-text">minutes</div>
                </div>
                <div class="timer-box">
                  <div class="timer-number">0</div>
                  <div class="timer-text">seconds</div>
                </div>
              </div>}
              {(!isEmptyDash(rfqDetails?.rfqValidity?.to)) && <DayCountdown targetDate={new Date(rfqDetails?.rfqValidity?.to)} status={rfqDetails?.status} />}
              <div class="date-picker-container">
                <form>
                  <div class="date-range">
                    <label class="rfq-label" for="rfqValidity">
                      RFQ Validity:
                    </label>
                    <div className="lets_rfq_detail_bidding">
                      <div class="from">
                        <label for="fromDate">From:</label>
                        <input
                          className="form-control form-haswe"
                          type="date"
                          id="fromDate"
                          name="from"
                          value={(isEmptyDash(rfqDetails?.rfqValidity?.from)) ? null : strToDateYYMMDD(rfqDetails?.rfqValidity?.from)}
                          onChange={rfqValidityChange}
                          min={todayDate}
                          disabled={(userRole === "VENDOR") ? 'disabled' : !(isEditRFQ == true)}
                        />
                      </div>
                      <div class="to">
                        <label for="toDate">To:</label>
                        <input
                          className="form-control form-haswe"
                          type="date"
                          id="toDate"
                          name="to"
                          value={(isEmptyDash(rfqDetails?.rfqValidity?.to)) ? null : strToDateYYMMDD(rfqDetails?.rfqValidity?.to)}
                          onChange={rfqValidityChange}
                          min={rfqDetails?.rfqValidity?.from ? rfqDetails.rfqValidity.from : todayDate}

                          disabled={(userRole === "VENDOR") ? 'disabled' : !(isEditRFQ == true)}
                        />
                      </div> 
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="package_code_bfwd_listing_block_no1" style={{marginBottom:'20px'}}>
            {!isEmptyDash(rfqDetails?.packageCode) && <div className="package_code_block_body">
              <label> Package Code: </label>
              <label class="lets_pakage_code_creation"> 
                {/* {rfqDetails?.packageCode} */}
              <Tooltip title={rfqDetails?.packageCode}> {trimString(rfqDetails?.packageCode, 20)}</Tooltip>
              </label>
            </div>}
            {!isEmptyDash(rfqDetails?.rfqNumber) && <div className="package_code_block_body">
              <label> RFQ Number: </label>
              <label class="lets_pakage_code_creation"> 
                {/* {rfqDetails?.rfqNumber} */}
              <Tooltip title={rfqDetails?.rfqNumber}> {trimString(rfqDetails?.rfqNumber, 20)}</Tooltip>
              </label>
            </div>}
            {!isEmptyDash(rfqDetails?.projectCode) && <div className="package_code_block_body">
              <label> Project Code: </label>
              <label class="lets_pakage_code_creation"> 
                {/* {rfqDetails?.projectCode} */}
              <Tooltip title={rfqDetails?.projectCode}> {trimString(rfqDetails?.projectCode, 20)}</Tooltip>
              </label>
            </div>}
          </div>
          <div className="listing_packagedetail_block_mainsection1"> 
              { Array.isArray(activefields) && activefields[0]?.fields?.map((ele, i) => (
                  <>  
                      {ele.uniqueName === "purchaseType" && ele.display === true && ( 
                          <div className="listing_project_block_2_1">
                            <div className="listing_project_block_3">
                              <p className="project_code_texts_creationlisbv"><b>{ele.name} {ele?.required && <span className="required">*</span>}</b> </p>
                              {ele.type === "Dropdown" && ele.options?.length > 0 && (
                                <Tooltip title={rfqDetails[ele.uniqueName]}>
                                <select
                                  className="form-select package_creation_form_detail"
                                  aria-label="Default select example"
                                  name={ele.uniqueName}
                                  value={trimString(rfqDetails[ele.uniqueName] || "", 20)}
                                  // value={rfqDetails[ele.uniqueName] || ""}
                                  onChange={onTextChange1}
                                  disabled={(userRole === "VENDOR") ? 'disabled' : !(isEditRFQ === true && isAgainstPkg === false)} 
                                >
                                  <option>Select</option> 
                                  {ele.options.map((option, optionIndex) => (
                                    !option.isDeleted && (
                                      <option key={option._id} value={option.optionName}>
                                        {option.optionName}
                                      </option>
                                    )
                                  ))}
                                </select>
                                </Tooltip>
                              )} 
                            </div>
                          </div>
                      )} 
                      {ele.display === true  && ele?.static === false  && ( 
                            <div key={i} className="listing_project_block_2_1">
                            <div className="listing_project_block_3">
                            <p className="project_code_texts_creationlisbv"><b> {ele?.name} {ele?.required && <span className="required">*</span>}</b></p>

                                {ele.type === "String" && (
                                <Tooltip title={rfqDetails?.additionalFields?.[ele.uniqueName]}>
                                  <input
                                    className="form-control form-haswes"
                                    type="text"
                                    placeholder={`Enter ${ele?.name}`}
                                    name={ele.uniqueName}
                                    // value={rfqDetails?.additionalFields?.[ele.uniqueName] || ''}
                                    value={trimString(rfqDetails?.additionalFields?.[ele.uniqueName] || "", 20)}
                                    onChange={onTextChange}
                                    disabled={userRole === "VENDOR" || !(isEditRFQ === true && isAgainstPkg === false)}
                                  />
                                  </Tooltip>
                                )} 
                                {ele.type === "Dropdown" && ele.options?.length > 0 && (
                                      <Tooltip title={rfqDetails?.additionalFields?.[ele.uniqueName]}>
                                  <select
                                    className="form-select package_creation_form_detail"
                                    aria-label="Default select example"
                                    name={ele.uniqueName}
                                    // value={rfqDetails?.additionalFields?.[ele.uniqueName] || ""}
                                    value={trimString(rfqDetails?.additionalFields?.[ele.uniqueName] || "", 20)}
                                    onChange={onTextChange}
                                    disabled={(userRole === "VENDOR") ? 'disabled' : !(isEditRFQ === true && isAgainstPkg === false)}
                                  >
                                    <option>Select</option>
                                    {ele.options.map((option) => (
                                      !option.isDeleted && (
                                        <option key={option._id} value={option.optionName}>
                                          {option.optionName}
                                        </option>
                                      )
                                    ))}
                                  </select>
                                  </Tooltip>
                                )} 
                                {ele.type === "Number" && (
                                <Tooltip title={rfqDetails?.additionalFields?.[ele.uniqueName]}>
                                  <input
                                    className="form-control selected_lrcreactionpsnrow"
                                    type="number"
                                    placeholder={`Enter ${ele?.name}`}
                                    name={ele.uniqueName}
                                    // value={rfqDetails?.additionalFields?.[ele.uniqueName] || ""}
                                    value={trimString(rfqDetails?.additionalFields?.[ele.uniqueName] || "", 20)}
                                    onChange={onTextChange}
                                    min="0" 
                                    required={ele.required}
                                    disabled={(userRole === "VENDOR") ? 'disabled' : !(isEditRFQ === true && isAgainstPkg === false)}
                                  />
                                  </Tooltip>
                                )} 

                              </div>
                            </div>
                      )}  

                    </>
              ))} 
          </div>
          <div class="boq_search_filter_row ms-auto" style={{ marginBottom: '0px' }}>
            <h5 className="lets_boq_outer">BOQ</h5> 
            <div style={{ display: "flex" }}>
              {(rfqDetails?.status != "Round_2_Completed") && <div class="create_listing_project down_teh_comer">
                <div className="creaction_form_editpage_boqrow">   
                  <div class="create_listing_project">
                    {/* <button
                  onClick={() => {
                    setOpenCreationUpdateBoqModal(true);
                  }}
                  type="button"
                  class="btn btn-light"
                >
                  Update BOQ
                </button> */}
                    {/* <button
                  onClick={() => {
                    setOpenRfqCreationNotificationModifiedModal(true);
                  }}
                  type="button"
                  class="btn btn-light"
                >
                  Edit BOQ
                </button> */} 
                  {(statusArr.indexOf(rfqDetails?.status) < 6  && statusArr.indexOf(rfqDetails?.status) !== -1  && userRole === 'BUYER' && isEmptyDash(rfqDetails?.packageCode)) && (
                  <div class="create_listing_projects">
                    <button onClick={() => setOpenBulkUploadModal(true)}  className="gate_btn_lr_creations">
                      Excel Upload
                    </button>
                 </div>
                )}
                    {(rfqDetails?.status !== 'RFQ Expired') && (secRFQPermission["EDIT_RFQ"]?.read == true && isEditButtonPermission()) && <button
                      onClick={() => {
                        setOpenRfqCreationNotificationModifiedModal(true);
                      }}
                      className="gate_btn_lr_creations"
                    >
                      <EditIcon />
                      {userRole == "VENDOR" ? "Participate" : 'Edit RFQ'}
                    </button>}

                   
                    {(userRole == "VENDOR") && <button
                      onClick={downloadVendorRFQ}
                      className="gate_btn_lr_creations"
                    >
                      <DownloadIcon />
                      Download
                    </button>}
                    {(secRFQPermission["TECHNICAL_EVALUATION"]?.read == true && isTechEvaluation("Initiate") && userId === rfqDetails?.engineerAssignee) && <button
                      // onClick={() => techComEvaluation("Technical", 1)}
                      onClick={() => handleEvaluationButtonClick("Technical")}
                      className="gate_btn_lr_creations"
                      disabled={VendorParticipationStatus === false}
                    >
                      Technical Evaluation
                    </button>}

                    {(secRFQPermission["TECHNICAL_EVALUATION"]?.read == true && isTechEvaluation("Comparison")) && <button
                      onClick={() => navigateUrl(`/admin/Engineering-Bidding-Technical-Evaluation/${id}`)}
                      className="gate_btn_lr_creations"
                    >
                      Technical Comparision
                    </button>}
                    
                    {(secRFQPermission["COMMERCIAL_EVALUATION"]?.read == true && isComEvaluation("Initiate")) && <button
                      // onClick={() => techComEvaluation("Commercial", 1)}
                      onClick={() => handleEvaluationButtonClick("Commercial")}
                      className="gate_btn_lr_creations"
                      disabled={VendorParticipationStatus === false}
                    >
                      Commercial Evaluation
                    </button>}
                    {(rfqDetails?.activeRound?.commercialStatus !== 'Completed') && (secRFQPermission["COMMERCIAL_EVALUATION"]?.read == true && isComEvaluation("Comparison")) && <button
                      onClick={() => commercialNavigateUrl()}
                      className="gate_btn_lr_creations"
                    >
                      Commercial Comparison
                    </button>}
                  </div>
                </div><br/>
              </div>
              }
              <div style={{ marginLeft: "10px" }}>
              {(userRole === 'BUYER' && rfqDetails && rfqDetails.rfqNumber && rfqDetails.rfqNumber.startsWith('RFQ')) &&
                      <button
                        onClick={enableBlankPRNumberFields}
                        className="gate_btn_lr_creations"
                      // disabled={isDisable}
                      style={{ marginRight: "10px" }}
                      >
                        <EditIcon />
                        Add PR Number
                      </button>
                    }
                {(statusArr.indexOf(rfqDetails?.status) > 9 && userRole === 'BUYER') &&
                  <button style={{ marginRight: '3px' }}
                    onClick={() => navigateUrl(`/admin/Buyer-Bidding-Commercial-Comparision-Round-1/${id}`)}
                    className="gate_btn_lr_creations"
                  >
                    R1 Result
                  </button>
                }
                {(statusArr.indexOf(rfqDetails?.status) > 12 && userRole === 'BUYER') &&
                  <button
                    onClick={() => navigateUrl(`/admin/Buyer-Bidding-Commercial-Comparison/${id}`)}
                    className="gate_btn_lr_creations"
                  >
                    R2 Result
                  </button>
                }
              </div>
            </div>
          </div>
          <div className="search_main" style={{marginBottom:"20px"}}>
            <div id="custom-search-input">
              <div className="input-group col-md-12">
                <input   type="text"  className="form-control input-lg"
                  placeholder="Search here"
                  fdprocessedid="8achb" 
                  onChange={onFilterTextChange}
                  value={filterText}
                  onKeyPress={onKeyPressHandler}
                />
                <span className="input-group-btn">
                  <button
                    className="btn btn-info btn-lg"
                    type="button"
                    fdprocessedid="trsp06"
                  >
                    <span className="glyphicon glyphicon-search">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-search"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                      </svg>
                    </span>
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div className="listing_main rfq_SectionlistingMain_row">
            <table className="">
              <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                {(userRole == "VENDOR") && <tr className="row-label">
                  <th className="vendor_tabels" colSpan={6}></th>
                  <th className="vendor_tabels" colSpan={2}>Round 1</th>
                  {(statusArr.indexOf(rfqDetails?.status) > 10) && (
                    <th className="vendor_tabels" colSpan={2}>
                      Round 2 {rfqDetails?.vendorActiveRound?.totalAmount ? `(Total Avaada Amount: ${rfqDetails?.vendorActiveRound?.totalAmount})` : ''}
                    </th>
                  )}
                  {/* <th className="vendor_tabels">Description</th>
                  <th className="vendor_tabels">HSN/SAC Code</th>
                  <th className="vendor_tabels">UOM</th>
                  <th className="vendor_tabels">Quantity</th>
                  <th className="vendor_tabels">Rate (In INR)</th>
                  <th className="vendor_tabels">Amount (In INR)</th> */}
                </tr>}
                <tr>
                  <th className="vendor_tabels">Select</th>
                  <th className="vendor_tabels">Item No</th>
                  <th className="vendor_tabels">Description</th>
                  <th className="vendor_tabels">HSN/SAC Code</th>

                  {(userRole === 'BUYER' && rfqDetails && rfqDetails.rfqNumber && rfqDetails.rfqNumber.startsWith('RFQ')) &&
                    <th className="vendor_tabels">PR Number</th>
                  }
                  <th className="vendor_tabels">UOM</th>
                  <th className="vendor_tabels">Quantity</th>
                  <th className="vendor_tabels">Rate (In INR)</th>
                  <th className="vendor_tabels">Amount (In INR)</th>
                  {(statusArr.indexOf(rfqDetails?.status) > 10 && userRole == "VENDOR") && <th className="vendor_tabels">Rate (In INR)</th>}
                  {(statusArr.indexOf(rfqDetails?.status) > 10 && userRole == "VENDOR") && <th className="vendor_tabels">Amount (In INR)</th>}
                  <th className="vendor_tabels"></th>
                </tr>
              </thead>
              <tbody style={{ overflowY: "scroll", width: "200px" }}>
                {filteredRows.length < 1 && <>
                  <tr className="maine_tr_vendor">
                    <td colSpan={9} className="text-center">No Data Found</td>
                  </tr>
                </>}
                {filteredRows?.map((row, i) => <>
                  <tr>
                    <td>
                      <input type="checkbox" />
                    </td>
                    <td>{i + 1}</td>
                    <td>
                      <div style={{ marginTop: '0px', marginBottom: '0px' }}>
                        <div id="custom-search-input" style={{ padding: '0px' }}>
                          <div className="input-group col-md-12"> 
                            <Tooltip title={row.description}>
                              <input
                                className="form-control input-lg"
                                type="text"
                                // placeholder="Enter Description"
                                name="description"
                                // value={formatFileName(row.description)}
                                value={trimString(row.description || "", 20)}
                                onChange={(e) => handleInputChange(e, row, i)}
                                disabled={!(secRFQPermission["EDIT_DESCRIPTION_RFQ"]?.read == true && isEditRFQ == true && isAgainstPkg == false)}
                              />
                            </Tooltip>
                            {userRole !== "VENDOR" &&
                              <span className="input-group-btn">
                                <button
                                  className=""
                                  type="button"
                                  fdprocessedid="trsp06"
                                  onClick={() => handleEditClick(i)}
                                // disabled={isDisable}
                                >
                                  <span className="glyphicon glyphicon-search">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M12.146 0.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 3L3 11.207V13h1.793L13 4.793 11.207 3zM1 13.5V15h1.5l.896-.447-2-2L1 13.5z" />
                                    </svg>
                                  </span>
                                </button>
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="react_rfq_creation_modules_haswe">
                    <Tooltip title={row.hsnSacCode}>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        // placeholder="Enter HSN/SAC Code"
                        name="hsnSacCode"
                        // value={row.hsnSacCode}
                        value={trimString(row.hsnSacCode || "", 20)}
                        onChange={(e) => handleInputChange(e, row, i)}

                        disabled={
                          rfqDetails?.status !== 'Initiated' && rfqDetails?.status !== 'draft' &&
                          !(secRFQPermission["BOQ_EDIT_HSN/SAC_CODE"]?.read == true && row.isEdit == true && isEditRFQ == true)}
                      />
                      </Tooltip>
                      {userRole !== "VENDOR" && rfqDetails?.status !== 'Initiated' && rfqDetails?.status !== 'draft' &&
                        (row.isEdit !== true) && (
                          <ModeEditOutlineIcon className="lets_edit_pencil_body"
                            onClick={(e) => editHsnCode(e, row, i)}
                          />
                        )
                      }
                    </td>
                    {(userRole === 'BUYER' && rfqDetails && rfqDetails.rfqNumber && rfqDetails.rfqNumber.startsWith('RFQ')) && (
                      <td>
                      <Tooltip title={row.prNumber}>
                        <input
                          className="form-control form-haswe"
                          type="text"
                          // placeholder="Enter UOM"
                          name="prNumber"
                          // value={row.prNumber || ""}
                          value={trimString(row.prNumber  || "", 20)}
                          onChange={(e) => handlePRNumberChange(row.id, "prNumber", e.target.value, i)}
                          disabled={prNumberDisabled[i]}
                        />
                        </Tooltip>
                      </td>
                    )}
                    <td>
                    <Tooltip title={row.uom}>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        // placeholder="Enter UOM"
                        name="uom"
                        // value={row.uom}
                        value={trimString(row.uom  || "", 20)}
                        onChange={(e) => handleInputChange(e, row, i)}
                        disabled={!(secRFQPermission["EDIT_UOM_RFQ"]?.read == true && isEditRFQ == true && isAgainstPkg == false)}
                      />
                      </Tooltip>
                    </td>
                    <td>
                    <Tooltip title={row.quantity}>
                      <input
                        className="form-control form-haswe"
                        type="number"
                        // placeholder="Enter Quantity"
                        name="quantity"
                        // value={row.quantity}
                        value={trimString(row.quantity  || "", 20)}
                        onChange={(e) => handleInputChange(e, row, i)}
                        disabled={!(secRFQPermission["EDIT_QUANTITY_RFQ"]?.read == true && isEditRFQ == true && isAgainstPkg == false)}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-", "."].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip title={totalInr(getRateDataByRound(row, 1)?.rate || 0) }>
                        <input
                          className="form-control form-haswe"
                          type="number"
                          // placeholder="Enter Rate"
                          name="rate"
                          // value={row.rate}
                          value={getRateDataByRound(row, 1)?.rate }
                          onChange={(e) => handleInputChange(e, row, i, 1)}
                          disabled={!(secRFQPermission["BOQ_EDIT_RATE"]?.update == true && isEditRFQ == true && statusArr.indexOf(rfqDetails?.status) < 11)}
                          min="0"
                        />
                        </Tooltip>
                    </td>
                    <td>
                    <Tooltip title={totalInr(getRateDataByRound(row, 1)?.amount || 0) }>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        // placeholder="Enter Amount"
                        name="amount"
                        // value={row.amount}
                        // value={totalInr(getRateDataByRound(row, 1)?.amount || 0)}
                        value={trimString(totalInr(getRateDataByRound(row, 1)?.amount || 0)  || "", 20)}
                        onChange={(e) => handleInputChange(e, row, i, 1)}
                        disabled
                      />
                      </Tooltip>
                    </td>
                    {/* For Round 2 Column */}
                    {(statusArr.indexOf(rfqDetails?.status) > 10 && userRole == "VENDOR") && <td>
                      <Tooltip title={totalInr(getRateDataByRound(row, 2)?.rate)}>
                      <input
                        className="form-control form-haswe"
                        type="number"
                        // placeholder="Enter Rate"
                        name="rate"
                        // value={row.rate}
                        // value={totalInr(getRateDataByRound(row, 2)?.rate)}
                        value={trimString(getRateDataByRound(row, 2)?.rate  || "", 20)}
                        onChange={(e) => handleInputChange(e, row, i, 2)}
                        disabled={!(secRFQPermission["BOQ_EDIT_RATE"]?.update == true && isEditRFQ == true && statusArr.indexOf(rfqDetails?.status) > 10)}
                      />
                      </Tooltip>
                    </td>}
                    {(statusArr.indexOf(rfqDetails?.status) > 10 && userRole == "VENDOR") && <td>
                      <Tooltip title={totalInr(getRateDataByRound(row, 2)?.amount || 0) }>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        // placeholder="Enter Amount"
                        name="amount"
                        // value={row.amount}
                        // value={getRateDataByRound(row, 2)?.amount}
                        value={trimString(getRateDataByRound(row, 2)?.amount  || "", 20)}
                        onChange={(e) => handleInputChange(e, row, i, 2)}
                        disabled
                      />
                      </Tooltip>
                    </td>}
                    {(secRFQPermission?.BOQ_DELETE_ROW?.read == true && isEditRFQ == true && i != 0) && <td>
                      <HighlightOffIcon className="highlight_close_btn" onClick={() => confirmDelete(i)} />
                    </td>}
                  </tr >
                </>)}
                {(rfqDetails?.boqs.length > 0 && userRole == "VENDOR") && <tr className="row-label">
                  <th className="vendor_tabels" colSpan={6}></th>
                  <th className="vendor_tabels" >
                    {/* ₹ {Number(getTotalByRound(1)?.totalRate1) || 0} */}
                  </th>
                  <th className="vendor_tabels" >₹{totalInr(Number(getTotalByRound(1)?.totalAmount1) || 0)}</th>
                  {(statusArr.indexOf(rfqDetails?.status) > 10) && <th className="vendor_tabels" >
                    {/* ₹ {Number(getTotalByRound(2)?.totalRate2) || 0} */}
                  </th>}
                  {(statusArr.indexOf(rfqDetails?.status) > 10) && <th className="vendor_tabels" >₹ {Number(getTotalByRound(2)?.totalAmount2) || 0}</th>}
                </tr>}
              </tbody>
            </table>
          </div>
          <div>
            {(secRFQPermission?.BOQ_DELETE_ROW?.update == true && isEditRFQ == true) && isEmptyDash(rfqDetails?.packageCode) &&
              <button
                className="lets_add_row_react_btn_packagedetail1"
                tabindex="0"
                type="button"
                fdprocessedid="9un26w"
                onClick={handleAddRow}
              >
                <AddIcon /> Add Row
                <span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>}
            {/* <Button tabindex="0" type="button" fdprocessedid="9un26w">
              + Add Row
              <span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </Button> */}
            <div className="progress-div">
              <div>
                <p>Document Upload Progress </p>
              </div>
              <div className="d-flex">
                <div className="progress-clc-percent">{calcDocPercent()}%</div>
                <div className="progress-clc-percent-bar">
                  <BorderLinearProgress variant="determinate" value={calcDocPercent()} />
                </div>
                <div className="progress-clc-percent">100%</div>
              </div>
            </div>
          </div>
          <div></div>
          <div>
            <label>Remarks</label>
            <Tooltip title={rfqDetails?.remarks}>
            <input className="form-control form-hasw" type="text"
              name="remarks"
              // value={rfqDetails?.remarks}
              value={trimString(rfqDetails?.remarks  || "", 30)}
              onChange={onTextChange1}
              disabled={(userRole === "VENDOR") ? 'disabled' : !(secRFQPermission["EDIT_RFQ"]?.update == true && isEditRFQ == true)} 
            />
            </Tooltip>
          </div>   
          {rfqDetails?.rfqNumber?.startsWith('TEMP') ? (
           
            /** for Package Creation */
            <>    
            <div className="listing_block_maine_allbtn">
                <div className="package_detail_allbtn_projectmanager">
                  {Array.isArray(activeDocument) &&
                    activeDocument?.map((field, index) => { 
                      if (field.type === "File" && field.display === true) {
                        return (
                          <div key={index}>
                            <p className="package_projectmanager">
                              <Tooltip title={field.name || "N/A"}>
                                {field.name ? trimString(field.name, 20) : "N/A"}{field.required && <span className="required">*</span>}
                              </Tooltip>
                            </p> 
                              {
                                  ( Array.isArray(field?.value?.response) && field?.value?.response.length > 0) ? (
                                    /* if RFQ create using package */
                                    <>
                                      <div className="selected-file-present-div" style={{ display: "inline" }}>
                                        <span className="selected-file-present-text">
                                          Document: {field?.value?.response?.length || 0}
                                        </span>
                                      </div>
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => handleClick(field, index, "Package_Documents")}
                                      >
                                        View
                                      </button>
                                    </>
                                  ) : (Array.isArray(field.response) && field.response.length > 0) ? (  
                                    /* RFQ creation */
                                    <>
                                      <div className="selected-file-present-div" style={{ display: "inline" }}>
                                        <span className="selected-file-present-text">
                                          Document: {field.response?.length || 0}
                                        </span>
                                      </div>
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => handleClick(field, index, "Package_Documents")}
                                      >
                                        View
                                      </button>
                                    </>
                                  ) : (
                                    <div
                                      className="lets_block_package_listing_bom_file"
                                      style={{ display: "block" }}
                                    >
                                      <div>
                                        <button
                                          className="upload_file_bom_tendor_project_react"
                                          onClick={() => handlePackageButtonClick(index)}
                                          style={{ cursor: isEditRFQ ? "pointer" : "default" }}
                                          disabled={!isEditRFQ}
                                        >
                                          <CloudUploadIcon className="download_icon_react" />
                                          Upload File
                                        </button>
                                        <input
                                          type="file"
                                          ref={(element) => (filePackageInputRef.current[index] = element)}
                                          id={`ref${index}`}
                                          style={{ display: "none" }}
                                          onChange={(e) => uploadFile(e, field.uniqueName, index, 'Package_Doc')}
                                          disabled={!isEditRFQ}
                                        />
                                      </div>
                                    </div>
                                  )
                                }
                          </div>
                        );
                      }
                      return null;
                    })}
                </div>
            </div>  
            <div className="listing_block_maine_allbtn">
                <div className="package_detail_allbtn_projectmanager">
                  {Array.isArray(activeRFQDocument) &&
                    activeRFQDocument.map((field, index) => { 
                      if (field.type === "File" && field.display === true) {
                        return (
                          <div key={index}>
                            <p className="package_projectmanager">
                              <Tooltip title={field.name || "N/A"}>
                                {field.name ? trimString(field.name, 20) : "N/A"}{field.required && <span className="required">*</span>}
                              </Tooltip>
                            </p>

                            {( Array.isArray(field?.value?.response) && field?.value?.response.length > 0) ? (
                                    /* if RFQ create using package */
                                    <>
                                      <div className="selected-file-present-div" style={{ display: "inline" }}>
                                        <span className="selected-file-present-text">
                                          Document: {field?.value?.response?.length || 0}
                                        </span>
                                      </div>
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => handleClick(field, index, "RFQ_Documents")}
                                      >
                                        View
                                      </button>
                                    </>
                                  ) : Array.isArray(field.response) && field.response.length > 0 ? (
                              <>
                                <div className="selected-file-present-div" style={{ display: "inline" }}>
                                  <span className="selected-file-present-text">
                                    Document: {field.response?.length || 0}
                                  </span>
                                </div>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => handleClick(field, index, "RFQ_Documents")}
                                >
                                  View
                                </button>
                              </>
                            ) : (
                              <div
                                className="lets_block_package_listing_bom_file"
                                style={{ display: "block" }}
                              >
                                <div>
                                  <button
                                    className="upload_file_bom_tendor_project_react"
                                    onClick={() => handleRFQButtonClick(index)}
                                    style={{ cursor: isEditRFQ ? "pointer" : "default" }}
                                    disabled={!isEditRFQ}
                                  >
                                    <CloudUploadIcon className="download_icon_react" />
                                    Upload File
                                  </button>
                                  <input
                                    type="file"
                                    ref={(element) => (fileRFQInputRef.current[index] = element)}
                                    id={`ref${index}`}
                                    style={{ display: "none" }}
                                    onChange={(e) => uploadFile(e, field.uniqueName, index,'RFQ_doc')}
                                    disabled={!isEditRFQ}
                                  /> 
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      }
                      return null;
                    })}
                </div>
            </div> 
            </>
          ):(
               /** for RFQ Document Details */
            <> 

               <div className="listing_block_maine_allbtn">
               <div className="package_detail_allbtn_projectmanager">
                 {Array.isArray(activeDocument) &&
                   activeDocument.map((field, index) => {
                     if (field.type === "File" && field.display === true) {
                       return (
                         <div key={index}>
                           <p className="package_projectmanager">
                             <Tooltip title={field.name || "N/A"}>
                               {field.name ? trimString(field.name, 20) : "N/A"}
                               {field.required && <span className="required">*</span>}
                             </Tooltip>
                           </p>
                           {
                            
                                  (rfqDetails?.packageCode && Array.isArray(field?.value?.response) && field?.value?.response.length > 0) ? (
                                    /* if RFQ detail using package */
                                    <>
                                      <div className="selected-file-present-div" style={{ display: "inline" }}>
                                        <span className="selected-file-present-text">
                                          Document: {field?.value?.response?.length || 0}
                                        </span>
                                      </div>
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => handleClick(field, index, "Package_Documents")}
                                      >
                                        View
                                      </button>
                                    </>
                                  ) : ( Array.isArray(field?.value?.response) && field?.value?.response.length > 0) ? (
                                          <>
                                            <div
                                              className="selected-file-present-div"
                                              style={{ display: "inline" }}
                                            >
                                              <span className="selected-file-present-text">
                                                Document: {field?.value?.response.length || 0}
                                              </span>
                                            </div>
                                            <button
                                              className="btn btn-primary btn-sm"
                                              onClick={() => handleClick(field, index, "Package_Documents")}
                                            >
                                              View
                                            </button>
                                          </>
                                        ) : (
                                          <div
                                            className="lets_block_package_listing_bom_file"
                                            style={{ display: "block" }}
                                          >
                                            <div>
                                              <button
                                                className="upload_file_bom_tendor_project_react"
                                                onClick={() => handlePackageButtonClick(index)}
                                                style={{ cursor: isEditRFQ ? "pointer" : "default" }}
                                                disabled={!isEditRFQ}
                                              >
                                                <CloudUploadIcon className="download_icon_react" />
                                                Upload File
                                              </button>
                                              <input
                                                type="file"
                                                ref={(element) => (filePackageInputRef.current[index] = element)}
                                                id={`ref${index}`}
                                                style={{ display: "none" }}
                                                onChange={(e) =>
                                                  uploadFile(e, field.uniqueName, index,'Package_Doc')
                                                }
                                                disabled={!isEditRFQ}
                                              />
                                            </div>
                                          </div>
                                        )
                          }



{/*              
                           {Array.isArray(field?.value?.response) && field?.value?.response.length > 0 ? (
                             <>
                               <div
                                 className="selected-file-present-div"
                                 style={{ display: "inline" }}
                               >
                                 <span className="selected-file-present-text">
                                   Document: {field?.value?.response.length || 0}
                                 </span>
                               </div>
                               <button
                                 className="btn btn-primary btn-sm"
                                 onClick={() => handleClick(field, index, "Package_Documents")}
                               >
                                 View
                               </button>
                             </>
                           ) : (
                             <div
                               className="lets_block_package_listing_bom_file"
                               style={{ display: "block" }}
                             >
                               <div>
                                 <button
                                   className="upload_file_bom_tendor_project_react"
                                   onClick={() => handlePackageButtonClick(index)}
                                   style={{ cursor: isEditRFQ ? "pointer" : "default" }}
                                   disabled={!isEditRFQ}
                                 >
                                   <CloudUploadIcon className="download_icon_react" />
                                   Upload File
                                 </button>
                                 <input
                                   type="file"
                                   ref={(element) => (filePackageInputRef.current[index] = element)}
                                   id={`ref${index}`}
                                   style={{ display: "none" }}
                                   onChange={(e) =>
                                     uploadFile(e, field.uniqueName, index,'Package_Doc')
                                   }
                                   disabled={!isEditRFQ}
                                 />
                               </div>
                             </div>
                           )} */}


                         </div>
                       );
                     }
                     return null;
                   })}
               </div>
             </div>
             <div className="listing_block_maine_allbtn">
               <div className="package_detail_allbtn_projectmanager">
                 {Array.isArray(activeRFQDocument) &&
                   activeRFQDocument.map((field, index) => {
                     if (field.type === "File" && field.display === true) {
                       return (
                         <div key={index}>
                           <p className="package_projectmanager">
                             <Tooltip title={field.name || "N/A"}>
                               {field.name ? trimString(field.name, 20) : "N/A"}
                               {field.required && <span className="required">*</span>}
                             </Tooltip>
                           </p>
             
                           {Array.isArray(field?.value?.response) && field?.value?.response.length > 0 ? (
                             <>
                               <div
                                 className="selected-file-present-div"
                                 style={{ display: "inline" }}
                               >
                                 <span className="selected-file-present-text">
                                   Document: {field?.value?.response.length || 0}
                                 </span>
                               </div>
                               <button
                                 className="btn btn-primary btn-sm"
                                 onClick={() => handleClick(field, index,"RFQ_Documents")}
                               >
                                 View
                               </button>
                             </>
                           ) : (
                             <div
                               className="lets_block_package_listing_bom_file"
                               style={{ display: "block" }}
                             >
                               <div>
                                 <button
                                   className="upload_file_bom_tendor_project_react"
                                   onClick={() => handleRFQButtonClick(index)}
                                   style={{ cursor: isEditRFQ ? "pointer" : "default" }}
                                   disabled={!isEditRFQ}
                                 >
                                   <CloudUploadIcon className="download_icon_react" />
                                   Upload File
                                 </button>
                                 <input
                                   type="file"
                                   ref={(element) => (fileRFQInputRef.current[index] = element)}
                                   id={`ref${index}`}
                                   style={{ display: "none" }}
                                   onChange={(e) =>
                                     uploadFile(e, field.uniqueName, index ,'RFQ_doc')
                                   }
                                   disabled={!isEditRFQ} 
                                 /> 
                               </div>
                             </div>
                           )}
                         </div>
                       );
                     }
                     return null;
                   })}
               </div>
             </div>
             </>
          )}
          {(rfqDetails?.status !== 'RFQ Expired') && (secRFQPermission?.EXTEND_VENDOR?.update == true && statusArr.indexOf(rfqDetails?.status) < 7) && <div class="create_listing_project_divs_react_taxsolutions_div_listwq">
            <button
              onClick={() => { setOpenRfqExitingVenodr() }}
              className="gate_btn_lr_creations"
              type="button"
            >
              Choose Existing Vendor
            </button>
            <button
              onClick={() => {
                setCreateVendorOpen(true);
              }}
              className="gate_btn_lr_creationrfq"
              type="button"
            >
              <PersonIcon />
              Invite New Vendor
            </button>
          </div>}
          {(secRFQPermission?.EXTEND_VENDOR?.update == true && rfqDetails?.status == "Round_1_Completed") && <div className="select_round_elogs_div_react">
            <button
              onClick={initiateR2}
              className="gate_btn_lr_creationrfq"
              type="button"
            >
              Select for Round 2
            </button>
          </div>}
          {(secRFQPermission?.EXTEND_VENDOR?.read == true) && <div className="listing_main" style={{ overflowX: "scroll", maxHeight: "400px" }}>
            <table>
              <thead>
                <tr>
                  <th className="vendor_tabels">Select</th>
                  <th className="vendor_tabels">Vendor Code</th>
                  <th className="vendor_tabels">Vendor Name</th>
                  <th className="vendor_tabels">Email Id</th>
                  <th className="vendor_tabels">Category</th>
                  <th className="vendor_tabels">Vendor Type</th>
                  <th className="vendor_tabels">Participation Status</th>
                  <th className="vendor_tabels">Technical Evaluation</th>
                  <th className="vendor_tabels">chat</th>
                  {statusArr.indexOf(rfqDetails?.status) < 6 && userRole === 'BUYER' &&   (
                    <th className="vendor_tabels">Actions</th>
                  )}
                  {statusArr.indexOf(rfqDetails?.status) > 10 && (
                    <>
                      <th className="vendor_tabels">Round-2 Status</th>
                      <th className="vendor_tabels">Remarks</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {vendorTableDataArr.length < 1 && <>
                  <tr className="maine_tr_vendor">
                    <td colSpan={9} className="text-center">No Data Found</td>
                  </tr>
                </>}
                {vendorTableDataArr.map((vendorEle, index) => (
                  <>
                    <tr>
                      <td>
                        <input type="checkbox" onChange={(e) => handleCheckboxInitR2(e, vendorEle, index)} checked={vendorEle?.isChecked} disabled={vendorEle?.technicalEvaluationStatus === 'Rejected' || vendorEle?.participationStatus === 'Rejected'} />
                      </td>
                      <td>
                        {/* {vendorEle?.vendorId} */}
                      <Tooltip title={vendorEle?.vendorId}> {trimString(vendorEle?.vendorId, 20)}</Tooltip>
                      </td>
                      <td>
                        {/* {vendorEle?.vendorName} */}
                        <Tooltip title={vendorEle?.vendorName}> {trimString(vendorEle?.vendorName, 20)}</Tooltip>
                        </td>
                      <td>
                        {/* {vendorEle?.email} */}
                        <Tooltip title={vendorEle?.email}> {trimString(vendorEle?.email, 20)}</Tooltip>
                        </td>
                      <td>
                        {/* {vendorEle?.category} */}
                        <Tooltip title={vendorEle?.category}> {trimString(vendorEle?.category, 20)}</Tooltip>
                        </td>
                      <td>
                        {/* {vendorEle?.vendorType} */}
                        <Tooltip title={vendorEle?.vendorType}> {trimString(vendorEle?.vendorType, 20)}</Tooltip>
                        </td>
                      <td>
                        {/* {vendorEle?.participationStatus} */}
                        <Tooltip title={vendorEle?.participationStatus}> {trimString(vendorEle?.participationStatus, 20)}</Tooltip>
                        </td>
                      <td>
                        {/* {vendorEle?.technicalEvaluationStatus} */}
                        <Tooltip title={vendorEle?.technicalEvaluationStatus}> {trimString(vendorEle?.technicalEvaluationStatus, 20)}</Tooltip>
                        </td> 
                      <td>
                          <span onClick={() => vendorChatBoxClick(vendorEle?.vendorId)}>
                              <img className="msgIco-img" src={msgIco} alt="" />
                          </span>
                      </td>
                      {statusArr.indexOf(rfqDetails?.status) < 6 && userRole === 'BUYER' &&   (
                        <td><DeleteIcon
                          className="icon_color_electrical"
                          onClick={(e) => openDeleteModal(vendorEle?._id)}
                        /></td>
                      )}
                      {statusArr.indexOf(rfqDetails?.status) > 10 && (
                        <>
                          <td>
                            {/* {vendorEle?.round2Status} */}
                            <Tooltip title={vendorEle?.round2Status}> {trimString(vendorEle?.round2Status, 20)}</Tooltip>
                            </td>
                          <td>
                            {/* {vendorEle?.remarks} */}
                            <Tooltip title={vendorEle?.remarks}> {trimString(vendorEle?.remarks, 20)}</Tooltip>
                            </td>
                        </>
                      )}
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>}
          {/* <div className="react-bootstrap-table-projectmanager">
            <BootstrapTable
              remote={{ search: true, pagination: true, sort: true }}
              bootstrap4
              keyField="id"
              data={creactionformrfq}
              columns={columns1}
              sort={true}
              // pagination={paginationFactory()}
              onTableChange={handleTableChange}
              noDataIndication={"No Data Found"}
              pagination={paginationFactory({
                page:
                  requestPayload.pageNumber == 0
                    ? 1
                    : requestPayload.pageNumber,
                sizePerPage: requestPayload.pageSize,
                totalSize: creactionformrfq?.totalItems,
                showTotal: true,
                pageStartIndex: 1,
                paginationSize: 2,
              })}
            />
          </div> */}
          {(isEditRFQ == true) && <div class="closebtn_submit_block_btn">
            {((rfqDetails?.status == "Drafted" || rfqDetails?.status == "Initiated") && secRFQPermission?.DELETE_RFQ?.read == true) && <button
              type="button"
              class="btn clear_btn_status_block_lists"
              fdprocessedid="wshspp"
              onClick={() => setDeleteRFQModal(true)}
            >
              Discard
            </button>}

            <button
              type="button"
              class="btn clear_btn_status_block_lists"
              fdprocessedid="wshspp"
              onClick={reloadChanges}
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-success save_next_btns"
              fdprocessedid="cn5f6"
              onClick={() => submitForm(false)}
            >
              Save as Draft
            </button>
            <button
              type="button"
              class="btn btn-success save_next_btns"
              onClick={() => submitForm(true)}
            >
              Submit RFQ
            </button>
          </div>}

          {userRole === "BUYER" && prSaveButtonDisabled === true && (
            <div class="closebtn_submit_block_btn">
              <button
                type="button"
                class="btn btn-success save_next_btns"
                onClick={() => savePrNo()}
              >
                Save PR Number
              </button>
            </div>
          )}

          {/* Exsting Vendor Modal */}

          {/* Select Round 2 RFQ ButtonModal */}
          <Modal
            open={openselectroundtworfqdetailmodal}
            onClose={() => setOpenSelectRoundTwoRfqDetailModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenSelectRoundTwoRfqDetailModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <div>
                  <img src={checkImage} alt="" />
                </div>
                <p>
                  RFQ has been initiated for Round 2 bidding
                  <br /> successfully.
                </p>
                <p className="lets_selected_round_detail_invited">
                  Selected vendors will be notified.
                </p>
                <button
                  href="Listingrfqbuyerbidding.html"
                  type="button"
                  class="btn btn-success"
                >
                  <Link
                    className="solutions_block_body"
                    style={{ color: "white", textDecoration: "none" }}
                    to="/admin/Engineering-Bidding-Rfq-Listing"
                  >
                    Done
                  </Link>
                </button>
              </div>
            </Box>
          </Modal>

          {/* Select Round 2 Reject Remarks */}
          <Modal
            open={isRejectListModalOpen}
            onClose={() => setIsRejectListModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Reject Vendors</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setIsRejectListModalOpen(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <table className="w-100">
                  <thead>
                    <tr>
                      <th className="vendor_tabels">Vendor Name</th>
                      <th className="vendor_tabels">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {initiateObjR2?.Rejected.length < 1 && <>
                      <tr className="maine_tr_vendor">
                        <td colSpan={9} className="text-center">No Data Found</td>
                      </tr>
                    </>}
                    {initiateObjR2?.Rejected.map((vendorEle, index) => (
                      <>
                        <tr>
                          <td>{vendorEle?.vendorName}</td>
                          <td>
                            <input
                              class="form-control form-haswe"
                              type="text"
                              name="remarks"
                              value={vendorEle?.remarks}
                              onChange={(e) => handleInputRejectChange(e.target.value, index)}
                            // disabled={!(secRFQPermission["EDIT_DESCRIPTION_RFQ"]?.read == true && isEditRFQ == true)}
                            />
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="btn clear_btn"
                    data-dismiss="modal"
                    fdprocessedid="3gp3uc"
                    onClick={() => setIsRejectListModalOpen(false)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success save_next_btn"
                    fdprocessedid="7mrm8"
                    onClick={submitRejectVendorR2}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Submit RFQ ButtonModal */}
          <Modal
            open={openboqupdatesuccessfully}
            onClose={() => setOpenBoqUpdateSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style2} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  {editSubmitStatus === false ? 'Save RFQ as Draft' : 'Submit RFQ'}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  // onClick={() => setOpenBoqUpdateSuccessfully(false)}
                  onClick={() => navigateUrl(`/admin/Engineering-Bidding-Rfq-Listing`)}
                ></button>
              </div>
              <div class="modal-bodys">
                <div>
                  <img src={checkImage} alt="" />
                </div>
                {userRole == "VENDOR" ?
                  (editSubmitStatus === false  ? <p>Your data has been saved as draft, please revisit & submit to finalize & share details with Buyer.</p> : 
                  <p>Thank you for submitting your participation in the RFQ. Your rate and document details have been successfully shared with the buyer. You will be notified of any updates or further steps in the RFQ process. Thank you for your interest in this opportunity.</p>)
                  :
                  <p>
                    {editSubmitStatus === false
                      ? 'The RFQ has been saved as a draft'
                      : `RFQ has been successfully ${rfqDetails?.rfqNumber?.startsWith('TEMP') ? 'created' : 'updated'}`
                    }
                    <br />
                    {rfqDetails?.rfqNumber?.startsWith('TEMP') && (
                      <>RFQ No. {createdNewRFQNo !== 'undefined' ? createdNewRFQNo : rfqDetails?.rfqNumber}</>
                    )}
                  </p>
                }
                <button
                  type="button"
                  class="btn btn-success"
                  onClick={() => navigateUrl(`/admin/Engineering-Bidding-Rfq-Listing`)}
                >
                  Done
                  {/* <Link
                    to="/admin/Engineering-Bidding-Rfq-Listing"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Done
                  </Link> */}
                </button>
              </div>
            </Box>
          </Modal>
          {/* Edit BOQ   Modal  */}
          <Modal
            open={openrfqcreationnotificationmodifiedmodal}
            onClose={() => setOpenRfqCreationNotificationModifiedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() =>
                    setOpenRfqCreationNotificationModifiedModal(false)
                  }
                ></button>
              </div>
              <div class="modal-bodys">
                Are you sure you want to participate in this RFQ?
                <div class="clear_btn_status_modified_boq">
                  <button type="button" class="btn btn-secondary"
                    onClick={() =>
                      setOpenRfqCreationNotificationModifiedModal(false)
                    }
                  >
                    No
                  </button>
                  <button type="button" class="btn btn-success"
                    onClick={editRFQ}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* Delete RFQ   Modal  */}
          <Modal
            open={deleteRFQModal}
            onClose={() => setDeleteRFQModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() =>
                    setDeleteRFQModal(false)
                  }
                ></button>
              </div>
              <div class="modal-bodys">
                Are you sure you want to Cancel RFQ, this will delete this RFQ ?
                <div class="clear_btn_status_modified_boq">
                  <button type="button" class="btn btn-secondary"
                    onClick={() =>
                      setDeleteRFQModal(false)
                    }
                  >
                    No
                  </button>
                  <button type="button" class="btn btn-success"
                    onClick={cancelRFQ}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* Update BOQ Rfq Creaction Modal  */}
          <Modal
            open={opencreationupdateboqmodal}
            onClose={() => setOpenCreationUpdateBoqModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCreationUpdateBoqModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <img src={checkImage} alt="" />
                    <p>BOQ updated successfully</p>
                    <p></p>
                    <button type="button" class="btn btn-success save_next_btn">
                      <Link
                        style={{ color: "white", textDecoration: "none" }}
                        to="/admin/Engineering-Bidding-Rfq-Listing"
                      >
                        Done
                      </Link>
                    </button>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {showDeleteConfirmation && (
            <Modal
              open={showDeleteConfirmation}
              onClose={handleCancel}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">Confirm Delete</h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={handleDeleteCancel}
                  ></button>
                </div>
                <div class="modal-bodys">
                  Are you sure you want to delete this Line Item ?
                  <div class="clear_btn_status_modified_boq">
                    <button type="button" class="btn btn-secondary" onClick={handleDeleteCancel}>
                      No
                    </button>
                    <button type="button" class="btn btn-success" onClick={handleDeleteConfirm}>
                      Yes
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          )}
 
          {/* Evalation Confirmation  Modal  */}
          {showConfirmation && (
            <Modal
              open={showConfirmation}
              onClose={() => setShowConfirmation(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setShowConfirmation(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  This action will initiate {evaluationType} Evaluation. Are you sure you want to continue?
                  <div class="clear_btn_status_modified_boq">
                    <button type="button" class="btn btn-secondary"
                      onClick={handleCancel}
                    >
                      No
                    </button>
                    <button type="button" class="btn btn-success"
                      onClick={handleConfirm}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          )}

        </div >
      </div >
      <Modal
        open={deleteiconopen}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style1}
          className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
        >
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel"></h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeDeleteModal}
            ></button>
          </div>
          <div className="modal-body lets_list_cotegory_status_management_block_bodyP">
            <p className="lets_want_changes_delete_icon">
              Are you sure you really want to delete vendor?
            </p>
            <button
              type="button"
              className="btn clear_btn"
              data-bs-dismiss="modal"
              onClick={closeDeleteModal}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-success save_next_btn"
              onClick={confirmDeleteModal}
            >
              Confirm
            </button>
          </div>
        </Box>
      </Modal> 
      {
        (secRFQPermission?.EXTEND_VENDOR?.update == true) && <ExitingVendor
          existingVendor={existingVendor}
          closeExitingVendorRFQModal={closeExitingVendorModal}
          getExistingVendorRfqList={getExistingVendorRfqList}
          onCheckboxChange={handleCheckboxChange}
          vendorList={existingVendorDataList}
          submitExistingVendorId={submitExistingVendorId}
          selectedVendorIds={selectedVendorIds}
          rfqVendorsIds={rfqDetails?.rfqVendors}
        />
      }
      <PackageDocuments
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={uploadFilesObj}
        onUploadMedia={onUploadMedia}
        deleteFile={deleteFile}
        vendorPartStatus = {rfqDetails?.vendorActiveRound?.participationStatus}
        isSubmitCondition={userRole == "VENDOR" && rfqDetails?.vendorActiveRound?.participationStatus !== "Rejected"}
        onMediaActionChange={onMediaActionChange}
        acceptAcknowledge={acceptAcknowledge}
        isColumn={{
          "DELETE": rfqDetails?.packageCode ? getRFQDocPermission(uploadFilesObj)?.update : (userRole == "BUYER") ? true : false,
          "INPUT_UPLOAD": getRFQDocPermission(uploadFilesObj)?.update && (statusArr.indexOf(rfqDetails?.status) < 6 ),
          "STATUS": userRole == "VENDOR",
          "VENDOR_DOC": userRole == "VENDOR",
          "REMARKS": userRole == "VENDOR",
        }}
      />

      {/* Invited New Vendor Modal */}
      <CreateNewVendorModal
        createVendorOpen={createVendorOpen}
        inviteQuesArr={inviteQuesArr}
        inviteModalClose={inviteModalClose}
        validateForm={validateForm}
        modalMsg="Create Vendor Onboarding"
      />

      {
        (userRole == "VENDOR" && rfqDetails?.vendorActiveRound?.participationStatus !== "Pending_To_Participate") && <SupportChat
          vendorDetails={vendorDetails} //{{ vendor: { _id: vendorDetails?._id } }} 
          isComparison={true}
          comparisonData={{
            isActive: true,
            vendorName: vendorDetails?.vendor?.vendorName,
            rfqId: id,
          }}
        />
      }
      {
        isModalOpen && (
          <BoqDescriptionModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            handleModalSubmit={handleModalSubmit}
            setModalDescription={setModalDescription}
            modalDescription={modalDescription}
            isEditDescription={(secRFQPermission["EDIT_DESCRIPTION_RFQ"]?.read == true && isEditRFQ == true && isAgainstPkg == false)}
            title="Description"
            isDisablee={!isEditRFQ == true}
          />
        )
      } 

            <BulkUploadModal
            createTableArr={createTableArr1}
            openBulkUploadModal={openBulkUploadModal}
            setOpenBulkUploadModal={setOpenBulkUploadModal}
            onBulkUploadSubmit={onBulkUploadSubmit}
            onsetOpenDefaulfFields={onsetOpenDefaulfFields}
            openDefaulfFields={openDefaulfFields}
            sampleProjectFile={sampleRFQFile}
            title="Create BOQ (Upload Excel File)"
          />
 

        {(vendorTableDataArr?.length > 0) && (
        <>
          {vendorTableDataArr?.map((rfqVendorsEle, i) => <>
            <SupportChat
              vendorDetails={{ vendor: { _id: rfqVendorsEle?._id } }}
              isComparison={true}
              comparisonData={{
                isActive: rfqVendorsEle?.vendorId == activeChatVendorId,
                vendorName: rfqVendorsEle?.vendorName,
                rfqId: id,
                isVendorChatBoxOpen: isVendorChatBoxOpen, 
              }}
              onMinimize={handleChatboxMinimize}
            />
          </>)}
        </>
      )}


      {/* {
        (userRole === "BUYER"  && <SupportChat
          vendorDetails= {{ vendor: { _id: vendorDetails?._id } }} 
          isComparison={true}
          comparisonData={{
            isActive: true,
            vendorName: vendorDetails?.vendor?.vendorName,
            rfqId: id,
            isVendorChatBoxOpen: isVendorChatBoxOpen,
          }}
          onMinimize={handleChatboxMinimize}
        />
      )} */}


      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default RfqCreactionForm;
